// Generated with our favorite GPT

/*
Structure:

{
  "hiragana": {
    "a"{
      "title": "あ",
      "tags": [ "main_kana" ],
      "characters": {
        "a": {
          "jp_character": "あ",
          "romanji": [ "a" ],
          "sound": "あ"
        },
        "i": {
          "jp_character": "い",
          "romanji": [ "i" ],
          "sound": "い"
        },
                . . .
      }
    },
    "k": {
      "title": "か",
      "tags": [ "main_kana" ],
      "characters": {
        "a": {
          "jp_character": "か",
          "romanji": [ "ka" ],
          "sound": "か"
        },
        "i": {
          "jp_character": "き",
          "romanji": [ "ki" ],
          "sound": "き"
        },
                . . .
      }
    }
  },
  "katakana": {
        . . .
  },
  "words": {
    "title": "words",
    "tags": [ "main_kana" ],
    "characters": {
      "kawaii": {
        "jp_character": "かわいい",
        "romanji": [ "kawaii" ],
        "sound": "かわいい",
        "meaning": "cute"
      },
      "jouzu": {
        "jp_character": "じょうず",
        "romanji": [ "jouzu" ],
        "sound": "じょうず",
        "meaning": "skillful"
      }
    }
  }
}
*/
export const kanaCharacters = {
  "hiragana": {
    "a": {
      "title": "あ",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "あ",
          "romanji": [
            "a"
          ],
          "sound": "あ"
        },
        "i": {
          "jp_character": "い",
          "romanji": [
            "i"
          ],
          "sound": "い"
        },
        "u": {
          "jp_character": "う",
          "romanji": [
            "u"
          ],
          "sound": "う"
        },
        "e": {
          "jp_character": "え",
          "romanji": [
            "e"
          ],
          "sound": "え"
        },
        "o": {
          "jp_character": "お",
          "romanji": [
            "o"
          ],
          "sound": "お"
        }
      }
    },
    "k": {
      "title": "か",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "か",
          "romanji": [
            "ka"
          ],
          "sound": "か"
        },
        "i": {
          "jp_character": "き",
          "romanji": [
            "ki"
          ],
          "sound": "き"
        },
        "u": {
          "jp_character": "く",
          "romanji": [
            "ku"
          ],
          "sound": "く"
        },
        "e": {
          "jp_character": "け",
          "romanji": [
            "ke"
          ],
          "sound": "け"
        },
        "o": {
          "jp_character": "こ",
          "romanji": [
            "ko"
          ],
          "sound": "こ"
        }
      }
    },
    "s": {
      "title": "さ",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "さ",
          "romanji": [
            "sa"
          ],
          "sound": "さ"
        },
        "i": {
          "jp_character": "し",
          "romanji": [
            "shi"
          ],
          "sound": "し"
        },
        "u": {
          "jp_character": "す",
          "romanji": [
            "su"
          ],
          "sound": "す"
        },
        "e": {
          "jp_character": "せ",
          "romanji": [
            "se"
          ],
          "sound": "せ"
        },
        "o": {
          "jp_character": "そ",
          "romanji": [
            "so"
          ],
          "sound": "そ"
        }
      }
    },
    "t": {
      "title": "た",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "た",
          "romanji": [
            "ta"
          ],
          "sound": "た"
        },
        "i": {
          "jp_character": "ち",
          "romanji": [
            "chi"
          ],
          "sound": "ち"
        },
        "u": {
          "jp_character": "つ",
          "romanji": [
            "tsu"
          ],
          "sound": "つ"
        },
        "e": {
          "jp_character": "て",
          "romanji": [
            "te"
          ],
          "sound": "て"
        },
        "o": {
          "jp_character": "と",
          "romanji": [
            "to"
          ],
          "sound": "と"
        }
      }
    },
    "n": {
      "title": "な",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "な",
          "romanji": [
            "na"
          ],
          "sound": "な"
        },
        "i": {
          "jp_character": "に",
          "romanji": [
            "ni"
          ],
          "sound": "に"
        },
        "u": {
          "jp_character": "ぬ",
          "romanji": [
            "nu"
          ],
          "sound": "ぬ"
        },
        "e": {
          "jp_character": "ね",
          "romanji": [
            "ne"
          ],
          "sound": "ね"
        },
        "o": {
          "jp_character": "の",
          "romanji": [
            "no"
          ],
          "sound": "の"
        }
      }
    },
    "h": {
      "title": "は",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "は",
          "romanji": [
            "ha"
          ],
          "sound": "は"
        },
        "i": {
          "jp_character": "ひ",
          "romanji": [
            "hi"
          ],
          "sound": "ひ"
        },
        "u": {
          "jp_character": "ふ",
          "romanji": [
            "fu"
          ],
          "sound": "ふ"
        },
        "e": {
          "jp_character": "へ",
          "romanji": [
            "he"
          ],
          "sound": "へ"
        },
        "o": {
          "jp_character": "ほ",
          "romanji": [
            "ho"
          ],
          "sound": "ほ"
        }
      }
    },
    "m": {
      "title": "ま",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ま",
          "romanji": [
            "ma"
          ],
          "sound": "ま"
        },
        "i": {
          "jp_character": "み",
          "romanji": [
            "mi"
          ],
          "sound": "み"
        },
        "u": {
          "jp_character": "む",
          "romanji": [
            "mu"
          ],
          "sound": "む"
        },
        "e": {
          "jp_character": "め",
          "romanji": [
            "me"
          ],
          "sound": "め"
        },
        "o": {
          "jp_character": "も",
          "romanji": [
            "mo"
          ],
          "sound": "も"
        }
      }
    },
    "y": {
      "title": "や",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "や",
          "romanji": [
            "ya"
          ],
          "sound": "や"
        },
        "u": {
          "jp_character": "ゆ",
          "romanji": [
            "yu"
          ],
          "sound": "ゆ"
        },
        "o": {
          "jp_character": "よ",
          "romanji": [
            "yo"
          ],
          "sound": "よ"
        }
      }
    },
    "r": {
      "title": "ら",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ら",
          "romanji": [
            "ra"
          ],
          "sound": "ら"
        },
        "i": {
          "jp_character": "り",
          "romanji": [
            "ri"
          ],
          "sound": "り"
        },
        "u": {
          "jp_character": "る",
          "romanji": [
            "ru"
          ],
          "sound": "る"
        },
        "e": {
          "jp_character": "れ",
          "romanji": [
            "re"
          ],
          "sound": "れ"
        },
        "o": {
          "jp_character": "ろ",
          "romanji": [
            "ro"
          ],
          "sound": "ろ"
        }
      }
    },
    "w": {
      "title": "わ",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "わ",
          "romanji": [
            "wa"
          ],
          "sound": "わ"
        },
        "o": {
          "jp_character": "を",
          "romanji": [
            "wo"
          ],
          "sound": "を"
        },
        "u": {
          "jp_character": "ん",
          "romanji": [
            "n"
          ],
          "sound": "ん"
        }
      }
    },
    "g": {
      "title": "が",
      "tags": [
        "dakuten_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "が",
          "romanji": [
            "ga"
          ],
          "sound": "が"
        },
        "i": {
          "jp_character": "ぎ",
          "romanji": [
            "gi"
          ],
          "sound": "ぎ"
        },
        "u": {
          "jp_character": "ぐ",
          "romanji": [
            "gu"
          ],
          "sound": "ぐ"
        },
        "e": {
          "jp_character": "げ",
          "romanji": [
            "ge"
          ],
          "sound": "げ"
        },
        "o": {
          "jp_character": "ご",
          "romanji": [
            "go"
          ],
          "sound": "ご"
        }
      }
    },
    "z": {
      "title": "ざ",
      "tags": [
        "dakuten_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ざ",
          "romanji": [
            "za"
          ],
          "sound": "ざ"
        },
        "i": {
          "jp_character": "じ",
          "romanji": [
            "ji"
          ],
          "sound": "じ"
        },
        "u": {
          "jp_character": "ず",
          "romanji": [
            "zu"
          ],
          "sound": "ず"
        },
        "e": {
          "jp_character": "ぜ",
          "romanji": [
            "ze"
          ],
          "sound": "ぜ"
        },
        "o": {
          "jp_character": "ぞ",
          "romanji": [
            "zo"
          ],
          "sound": "ぞ"
        }
      }
    },
    "d": {
      "title": "だ",
      "tags": [
        "dakuten_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "だ",
          "romanji": [
            "da"
          ],
          "sound": "だ"
        },
        "i": {
          "jp_character": "ぢ",
          "romanji": [
            "ji"
          ],
          "sound": "ぢ"
        },
        "u": {
          "jp_character": "づ",
          "romanji": [
            "zu"
          ],
          "sound": "づ"
        },
        "e": {
          "jp_character": "で",
          "romanji": [
            "de"
          ],
          "sound": "で"
        },
        "o": {
          "jp_character": "ど",
          "romanji": [
            "do"
          ],
          "sound": "ど"
        }
      }
    },
    "b": {
      "title": "ば",
      "tags": [
        "dakuten_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ば",
          "romanji": [
            "ba"
          ],
          "sound": "ば"
        },
        "i": {
          "jp_character": "び",
          "romanji": [
            "bi"
          ],
          "sound": "び"
        },
        "u": {
          "jp_character": "ぶ",
          "romanji": [
            "bu"
          ],
          "sound": "ぶ"
        },
        "e": {
          "jp_character": "べ",
          "romanji": [
            "be"
          ],
          "sound": "べ"
        },
        "o": {
          "jp_character": "ぼ",
          "romanji": [
            "bo"
          ],
          "sound": "ぼ"
        }
      }
    },
    "p": {
      "title": "ぱ",
      "tags": [
        "dakuten_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ぱ",
          "romanji": [
            "pa"
          ],
          "sound": "ぱ"
        },
        "i": {
          "jp_character": "ぴ",
          "romanji": [
            "pi"
          ],
          "sound": "ぴ"
        },
        "u": {
          "jp_character": "ぷ",
          "romanji": [
            "pu"
          ],
          "sound": "ぷ"
        },
        "e": {
          "jp_character": "ぺ",
          "romanji": [
            "pe"
          ],
          "sound": "ぺ"
        },
        "o": {
          "jp_character": "ぽ",
          "romanji": [
            "po"
          ],
          "sound": "ぽ"
        }
      }
    }
  },
  "katakana": {
    "a": {
      "title": "ア",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ア",
          "romanji": [
            "a"
          ],
          "sound": "ア"
        },
        "i": {
          "jp_character": "イ",
          "romanji": [
            "i"
          ],
          "sound": "イ"
        },
        "u": {
          "jp_character": "ウ",
          "romanji": [
            "u"
          ],
          "sound": "ウ"
        },
        "e": {
          "jp_character": "エ",
          "romanji": [
            "e"
          ],
          "sound": "エ"
        },
        "o": {
          "jp_character": "オ",
          "romanji": [
            "o"
          ],
          "sound": "オ"
        }
      }
    },
    "k": {
      "title": "カ",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "カ",
          "romanji": [
            "ka"
          ],
          "sound": "カ"
        },
        "i": {
          "jp_character": "キ",
          "romanji": [
            "ki"
          ],
          "sound": "キ"
        },
        "u": {
          "jp_character": "ク",
          "romanji": [
            "ku"
          ],
          "sound": "ク"
        },
        "e": {
          "jp_character": "ケ",
          "romanji": [
            "ke"
          ],
          "sound": "ケ"
        },
        "o": {
          "jp_character": "コ",
          "romanji": [
            "ko"
          ],
          "sound": "コ"
        }
      }
    },
    "s": {
      "title": "サ",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "サ",
          "romanji": [
            "sa"
          ],
          "sound": "サ"
        },
        "i": {
          "jp_character": "シ",
          "romanji": [
            "shi"
          ],
          "sound": "シ"
        },
        "u": {
          "jp_character": "ス",
          "romanji": [
            "su"
          ],
          "sound": "ス"
        },
        "e": {
          "jp_character": "セ",
          "romanji": [
            "se"
          ],
          "sound": "セ"
        },
        "o": {
          "jp_character": "ソ",
          "romanji": [
            "so"
          ],
          "sound": "ソ"
        }
      }
    },
    "t": {
      "title": "タ",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "タ",
          "romanji": [
            "ta"
          ],
          "sound": "タ"
        },
        "i": {
          "jp_character": "チ",
          "romanji": [
            "chi"
          ],
          "sound": "チ"
        },
        "u": {
          "jp_character": "ツ",
          "romanji": [
            "tsu"
          ],
          "sound": "ツ"
        },
        "e": {
          "jp_character": "テ",
          "romanji": [
            "te"
          ],
          "sound": "テ"
        },
        "o": {
          "jp_character": "ト",
          "romanji": [
            "to"
          ],
          "sound": "ト"
        }
      }
    },
    "n": {
      "title": "ナ",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ナ",
          "romanji": [
            "na"
          ],
          "sound": "ナ"
        },
        "i": {
          "jp_character": "ニ",
          "romanji": [
            "ni"
          ],
          "sound": "ニ"
        },
        "u": {
          "jp_character": "ヌ",
          "romanji": [
            "nu"
          ],
          "sound": "ヌ"
        },
        "e": {
          "jp_character": "ネ",
          "romanji": [
            "ne"
          ],
          "sound": "ネ"
        },
        "o": {
          "jp_character": "ノ",
          "romanji": [
            "no"
          ],
          "sound": "ノ"
        }
      }
    },
    "h": {
      "title": "ハ",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ハ",
          "romanji": [
            "ha"
          ],
          "sound": "ハ"
        },
        "i": {
          "jp_character": "ヒ",
          "romanji": [
            "hi"
          ],
          "sound": "ヒ"
        },
        "u": {
          "jp_character": "フ",
          "romanji": [
            "fu"
          ],
          "sound": "フ"
        },
        "e": {
          "jp_character": "ヘ",
          "romanji": [
            "he"
          ],
          "sound": "ヘ"
        },
        "o": {
          "jp_character": "ホ",
          "romanji": [
            "ho"
          ],
          "sound": "ホ"
        }
      }
    },
    "m": {
      "title": "マ",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "マ",
          "romanji": [
            "ma"
          ],
          "sound": "マ"
        },
        "i": {
          "jp_character": "ミ",
          "romanji": [
            "mi"
          ],
          "sound": "ミ"
        },
        "u": {
          "jp_character": "ム",
          "romanji": [
            "mu"
          ],
          "sound": "ム"
        },
        "e": {
          "jp_character": "メ",
          "romanji": [
            "me"
          ],
          "sound": "メ"
        },
        "o": {
          "jp_character": "モ",
          "romanji": [
            "mo"
          ],
          "sound": "モ"
        }
      }
    },
    "y": {
      "title": "ヤ",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ヤ",
          "romanji": [
            "ya"
          ],
          "sound": "ヤ"
        },
        "u": {
          "jp_character": "ユ",
          "romanji": [
            "yu"
          ],
          "sound": "ユ"
        },
        "o": {
          "jp_character": "ヨ",
          "romanji": [
            "yo"
          ],
          "sound": "ヨ"
        }
      }
    },
    "r": {
      "title": "ラ",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ラ",
          "romanji": [
            "ra"
          ],
          "sound": "ラ"
        },
        "i": {
          "jp_character": "リ",
          "romanji": [
            "ri"
          ],
          "sound": "リ"
        },
        "u": {
          "jp_character": "ル",
          "romanji": [
            "ru"
          ],
          "sound": "ル"
        },
        "e": {
          "jp_character": "レ",
          "romanji": [
            "re"
          ],
          "sound": "レ"
        },
        "o": {
          "jp_character": "ロ",
          "romanji": [
            "ro"
          ],
          "sound": "ロ"
        }
      }
    },
    "w": {
      "title": "ワ",
      "tags": [
        "main_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ワ",
          "romanji": [
            "wa"
          ],
          "sound": "ワ"
        },
        "o": {
          "jp_character": "ヲ",
          "romanji": [
            "wo"
          ],
          "sound": "ヲ"
        },
        "u": {
          "jp_character": "ン",
          "romanji": [
            "n"
          ]
        }
      }
    },
    "g": {
      "title": "ガ",
      "tags": [
        "dakuten_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ガ",
          "romanji": [
            "ga"
          ],
          "sound": "ガ"
        },
        "i": {
          "jp_character": "ギ",
          "romanji": [
            "gi"
          ],
          "sound": "ギ"
        },
        "u": {
          "jp_character": "グ",
          "romanji": [
            "gu"
          ],
          "sound": "グ"
        },
        "e": {
          "jp_character": "ゲ",
          "romanji": [
            "ge"
          ],
          "sound": "ゲ"
        },
        "o": {
          "jp_character": "ゴ",
          "romanji": [
            "go"
          ],
          "sound": "ゴ"
        }
      }
    },
    "z": {
      "title": "ザ",
      "tags": [
        "dakuten_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ザ",
          "romanji": [
            "za"
          ],
          "sound": "ザ"
        },
        "i": {
          "jp_character": "ジ",
          "romanji": [
            "ji"
          ],
          "sound": "ジ"
        },
        "u": {
          "jp_character": "ズ",
          "romanji": [
            "zu"
          ],
          "sound": "ズ"
        },
        "e": {
          "jp_character": "ゼ",
          "romanji": [
            "ze"
          ],
          "sound": "ゼ"
        },
        "o": {
          "jp_character": "ゾ",
          "romanji": [
            "zo"
          ],
          "sound": "ゾ"
        }
      }
    },
    "d": {
      "title": "ダ",
      "tags": [
        "dakuten_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "ダ",
          "romanji": [
            "da"
          ],
          "sound": "ダ"
        },
        "i": {
          "jp_character": "ヂ",
          "romanji": [
            "ji"
          ],
          "sound": "ヂ"
        },
        "u": {
          "jp_character": "ヅ",
          "romanji": [
            "zu"
          ],
          "sound": "ヅ"
        },
        "e": {
          "jp_character": "デ",
          "romanji": [
            "de"
          ],
          "sound": "デ"
        },
        "o": {
          "jp_character": "ド",
          "romanji": [
            "do"
          ],
          "sound": "ド"
        }
      }
    },
    "b": {
      "title": "バ",
      "tags": [
        "dakuten_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "バ",
          "romanji": [
            "ba"
          ],
          "sound": "バ"
        },
        "i": {
          "jp_character": "ビ",
          "romanji": [
            "bi"
          ],
          "sound": "ビ"
        },
        "u": {
          "jp_character": "ブ",
          "romanji": [
            "bu"
          ],
          "sound": "ブ"
        },
        "e": {
          "jp_character": "ベ",
          "romanji": [
            "be"
          ],
          "sound": "ベ"
        },
        "o": {
          "jp_character": "ボ",
          "romanji": [
            "bo"
          ],
          "sound": "ボ"
        }
      }
    },
    "p": {
      "title": "パ",
      "tags": [
        "dakuten_kana"
      ],
      "characters": {
        "a": {
          "jp_character": "パ",
          "romanji": [
            "pa"
          ],
          "sound": "パ"
        },
        "i": {
          "jp_character": "ピ",
          "romanji": [
            "pi"
          ],
          "sound": "ピ"
        },
        "u": {
          "jp_character": "プ",
          "romanji": [
            "pu"
          ],
          "sound": "プ"
        },
        "e": {
          "jp_character": "ペ",
          "romanji": [
            "pe"
          ],
          "sound": "ペ"
        },
        "o": {
          "jp_character": "ポ",
          "romanji": [
            "po"
          ],
          "sound": "ポ"
        }
      }
    }
  },
  "words": {
    "kawaii": {
      "jp_character": "かわいい",
      "romanji": [
        "kawaii"
      ],
      "sound": "かわいい",
      "meaning": "cute",
      "tags": ["adjectives", "expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "あ",
        "か"
      ]
    },
    "jouzu": {
      "jp_character": "じょうず",
      "romanji": [
        "jouzu"
      ],
      "sound": "じょうず",
      "meaning": "skillful",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "ざ"
      ]
    },
    "taberu": {
      "jp_character": "たべる",
      "romanji": [
        "taberu"
      ],
      "sound": "たべる",
      "meaning": "to eat",
      "tags": ["verbs", "food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "ば",
        "た"
      ]
    },
    "nomu": {
      "jp_character": "のむ",
      "romanji": [
        "nomu"
      ],
      "sound": "のむ",
      "meaning": "to drink",
      "tags": ["verbs", "food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "な"
      ]
    },
    "kurasu": {
      "jp_character": "くらす",
      "romanji": [
        "kurasu"
      ],
      "sound": "くらす",
      "meaning": "to live",
      "tags": ["verbs", "daily_life"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "か",
        "さ"
      ]
    },
    "benkyou": {
      "jp_character": "べんきょう",
      "romanji": [
        "benkyou"
      ],
      "sound": "べんきょう",
      "meaning": "study",
      "tags": ["basic"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "や",
        "あ",
        "か",
        "わ"
      ]
    },
    "koko": {
      "jp_character": "ここ",
      "romanji": [
        "koko"
      ],
      "sound": "ここ",
      "meaning": "here",
      "tags": ["demonstratives", "locations"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か"
      ]
    },
    "soko": {
      "jp_character": "そこ",
      "romanji": [
        "soko"
      ],
      "sound": "そこ",
      "meaning": "there",
      "tags": ["demonstratives", "locations"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か",
        "さ"
      ]
    },
    "asoko": {
      "jp_character": "あそこ",
      "romanji": [
        "asoko"
      ],
      "sound": "あそこ",
      "meaning": "over there",
      "tags": ["demonstratives", "locations"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "さ"
      ]
    },
    "nani": {
      "jp_character": "なに",
      "romanji": [
        "nani"
      ],
      "sound": "なに",
      "meaning": "what",
      "tags": ["question_words"],
      "katakana_groups": [],
      "hiragana_groups": [
        "な"
      ]
    },
    "doko": {
      "jp_character": "どこ",
      "romanji": [
        "doko"
      ],
      "sound": "どこ",
      "meaning": "where",
      "tags": ["question_words"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か",
        "だ"
      ]
    },
    "itsu": {
      "jp_character": "いつ",
      "romanji": [
        "itsu"
      ],
      "sound": "いつ",
      "meaning": "when",
      "tags": ["question_words"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "た"
      ]
    },
    "dare": {
      "jp_character": "だれ",
      "romanji": [
        "dare"
      ],
      "sound": "だれ",
      "meaning": "who",
      "tags": ["question_words"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "だ"
      ]
    },
    "wareware": {
      "jp_character": "われわれ",
      "romanji": [
        "wareware"
      ],
      "sound": "われわれ",
      "meaning": "we",
      "tags": ["pronouns", "people"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ら"
      ]
    },
    "anata": {
      "jp_character": "あなた",
      "romanji": [
        "anata"
      ],
      "sound": "あなた",
      "meaning": "you",
      "tags": ["pronouns", "people"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "た",
        "な"
      ]
    },
    "kare": {
      "jp_character": "かれ",
      "romanji": [
        "kare"
      ],
      "sound": "かれ",
      "meaning": "he",
      "tags": ["pronouns", "people"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "か"
      ]
    },
    "kanojo": {
      "jp_character": "かのじょ",
      "romanji": [
        "kanojo"
      ],
      "sound": "かのじょ",
      "meaning": "she",
      "tags": ["pronouns", "people"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "か",
        "ざ",
        "な"
      ]
    },
    "sore": {
      "jp_character": "それ",
      "romanji": [
        "sore"
      ],
      "sound": "それ",
      "meaning": "that",
      "tags": ["demonstratives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "さ"
      ]
    },
    "kore": {
      "jp_character": "これ",
      "romanji": [
        "kore"
      ],
      "sound": "これ",
      "meaning": "this",
      "tags": ["demonstratives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "か"
      ]
    },
    "kono": {
      "jp_character": "この",
      "romanji": [
        "kono"
      ],
      "sound": "この",
      "meaning": "this",
      "tags": ["demonstratives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か",
        "な"
      ]
    },
    "sono": {
      "jp_character": "その",
      "romanji": [
        "sono"
      ],
      "sound": "その",
      "meaning": "that",
      "tags": ["demonstratives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "さ",
        "な"
      ]
    },
    "ano": {
      "jp_character": "あの",
      "romanji": [
        "ano"
      ],
      "sound": "あの",
      "meaning": "that over there",
      "tags": ["demonstratives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "な"
      ]
    },
    "ookii": {
      "jp_character": "おおきい",
      "romanji": [
        "ookii"
      ],
      "sound": "おおきい",
      "meaning": "big",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か"
      ]
    },
    "chiisai": {
      "jp_character": "ちいさい",
      "romanji": [
        "chiisai"
      ],
      "sound": "ちいさい",
      "meaning": "small",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "さ",
        "た"
      ]
    },
    "samui": {
      "jp_character": "さむい",
      "romanji": [
        "samui"
      ],
      "sound": "さむい",
      "meaning": "cold",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "ま",
        "さ"
      ]
    },
    "takai": {
      "jp_character": "たかい",
      "romanji": [
        "takai"
      ],
      "sound": "たかい",
      "meaning": "expensive",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "た"
      ]
    },
    "yasui": {
      "jp_character": "やすい",
      "romanji": [
        "yasui"
      ],
      "sound": "やすい",
      "meaning": "cheap",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "さ"
      ]
    },
    "omoshiroi": {
      "jp_character": "おもしろい",
      "romanji": [
        "omoshiroi"
      ],
      "sound": "おもしろい",
      "meaning": "interesting",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "ま",
        "さ"
      ]
    },
    "tsumaranai": {
      "jp_character": "つまらない",
      "romanji": [
        "tsumaranai"
      ],
      "sound": "つまらない",
      "meaning": "boring",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "た",
        "ら",
        "あ",
        "な"
      ]
    },
    "kantan": {
      "jp_character": "かんたん",
      "romanji": [
        "kantan"
      ],
      "sound": "かんたん",
      "meaning": "easy",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "か",
        "た"
      ]
    },
    "muzukashii": {
      "jp_character": "むずかしい",
      "romanji": [
        "muzukashii"
      ],
      "sound": "むずかしい",
      "meaning": "difficult",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "ざ",
        "あ",
        "か",
        "さ"
      ]
    },
    "kiken": {
      "jp_character": "きけん",
      "romanji": [
        "kiken"
      ],
      "sound": "きけん",
      "meaning": "dangerous",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "か"
      ]
    },
    "yasashii": {
      "jp_character": "やさしい",
      "romanji": [
        "yasashii"
      ],
      "sound": "やさしい",
      "meaning": "kind",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "さ"
      ]
    },
    "kirai": {
      "jp_character": "きらい",
      "romanji": [
        "kirai"
      ],
      "sound": "きらい",
      "meaning": "hate",
      "tags": ["feelings", "adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "か"
      ]
    },
    "suki": {
      "jp_character": "すき",
      "romanji": [
        "suki"
      ],
      "sound": "すき",
      "meaning": "love",
      "tags": ["feelings", "adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か",
        "さ"
      ]
    },
    "tanoshii": {
      "jp_character": "たのしい",
      "romanji": [
        "tanoshii"
      ],
      "sound": "たのしい",
      "meaning": "pleasant",
      "tags": ["feelings", "adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "さ",
        "た",
        "な"
      ]
    },
    "kanashii": {
      "jp_character": "かなしい",
      "romanji": [
        "kanashii"
      ],
      "sound": "かなしい",
      "meaning": "sad",
      "tags": ["feelings", "adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "さ",
        "な"
      ]
    },
    "ureshii": {
      "jp_character": "うれしい",
      "romanji": [
        "ureshii"
      ],
      "sound": "うれしい",
      "meaning": "happy",
      "tags": ["feelings", "adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "さ"
      ]
    },
    "kanpai": {
      "jp_character": "かんぱい",
      "romanji": [
        "kanpai"
      ],
      "sound": "かんぱい",
      "meaning": "cheers",
      "tags": ["expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ぱ",
        "あ",
        "か"
      ]
    },
    "karaoke": {
      "jp_character": "カラオケ",
      "romanji": [
        "karaoke"
      ],
      "sound": "カラオケ",
      "meaning": "karaoke",
      "tags": ["entertainment", "social"],
      "katakana_groups": [
        "ラ",
        "ア",
        "カ"
      ],
      "hiragana_groups": []
    },
    "konbini": {
      "jp_character": "コンビニ",
      "romanji": [
        "konbini"
      ],
      "sound": "コンビニ",
      "meaning": "convenience store",
      "tags": ["places", "shopping"],
      "katakana_groups": [
        "バ",
        "ナ",
        "ワ",
        "カ"
      ],
      "hiragana_groups": []
    },
    "pasokon": {
      "jp_character": "パソコン",
      "romanji": [
        "pasokon"
      ],
      "sound": "パソコン",
      "meaning": "computer",
      "tags": ["items", "technology"],
      "katakana_groups": [
        "サ",
        "ワ",
        "カ",
        "パ"
      ],
      "hiragana_groups": []
    },
    "supootsu": {
      "jp_character": "スポーツ",
      "romanji": [
        "supootsu"
      ],
      "sound": "スポーツ",
      "meaning": "sports",
      "tags": ["activities", "hobbies"],
      "katakana_groups": [
        "サ",
        "タ",
        "パ"
      ],
      "hiragana_groups": []
    },
    "rajio": {
      "jp_character": "ラジオ",
      "romanji": [
        "rajio"
      ],
      "sound": "ラジオ",
      "meaning": "radio",
      "tags": ["items", "technology"],
      "katakana_groups": [
        "ザ",
        "ラ",
        "ア"
      ],
      "hiragana_groups": []
    },
    "tegami": {
      "jp_character": "てがみ",
      "romanji": [
        "tegami"
      ],
      "sound": "てがみ",
      "meaning": "letter",
      "tags": ["items", "communication"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "た",
        "が"
      ]
    },
    "pasu-poto": {
      "jp_character": "パスポート",
      "romanji": [
        "pasu-poto",
        "pasupooto"
      ],
      "sound": "パスポート",
      "meaning": "passport",
      "tags": ["items", "travel"],
      "katakana_groups": [
        "サ",
        "タ",
        "パ"
      ],
      "hiragana_groups": []
    },
    "biiru": {
      "jp_character": "ビール",
      "romanji": [
        "biiru"
      ],
      "sound": "ビール",
      "meaning": "beer",
      "tags": ["food", "drinks"],
      "katakana_groups": [
        "バ",
        "ラ"
      ],
      "hiragana_groups": []
    },
    "ko-hi-": {
      "jp_character": "コーヒー",
      "romanji": [
        "ko-hi-",
        "koohii"
      ],
      "sound": "コーヒー",
      "meaning": "coffee",
      "tags": ["food", "drinks"],
      "katakana_groups": [
        "ハ",
        "カ"
      ],
      "hiragana_groups": []
    },
    "mizu": {
      "jp_character": "みず",
      "romanji": [
        "mizu"
      ],
      "sound": "みず",
      "meaning": "water",
      "tags": ["food", "drinks"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "ざ"
      ]
    },
    "bi-do": {
      "jp_character": "ビード",
      "romanji": [
        "bi-do",
        "biido"
      ],
      "sound": "ビード",
      "meaning": "beard",
      "tags": ["basic"],
      "katakana_groups": [
        "バ",
        "ダ"
      ],
      "hiragana_groups": []
    },
    "miruku": {
      "jp_character": "ミルク",
      "romanji": [
        "miruku"
      ],
      "sound": "ミルク",
      "meaning": "milk",
      "tags": ["food", "drinks"],
      "katakana_groups": [
        "マ",
        "ラ",
        "カ"
      ],
      "hiragana_groups": []
    },
    "pan": {
      "jp_character": "パン",
      "romanji": [
        "pan"
      ],
      "sound": "パン",
      "meaning": "bread",
      "tags": ["food"],
      "katakana_groups": [
        "ワ",
        "パ"
      ],
      "hiragana_groups": []
    },
    "nihongo": {
      "jp_character": "にほんご",
      "romanji": [
        "nihongo"
      ],
      "sound": "にほんご",
      "meaning": "Japanese language",
      "tags": ["languages", "education"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "は",
        "な",
        "が"
      ]
    },
    "suika": {
      "jp_character": "すいか",
      "romanji": [
        "suika"
      ],
      "sound": "すいか",
      "meaning": "watermelon",
      "tags": ["food", "drinks"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "さ"
      ]
    },
    "ringo": {
      "jp_character": "りんご",
      "romanji": [
        "ringo"
      ],
      "sound": "りんご",
      "meaning": "apple",
      "tags": ["food", "fruits"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ら",
        "が"
      ]
    },
    "mikan": {
      "jp_character": "みかん",
      "romanji": [
        "mikan"
      ],
      "sound": "みかん",
      "meaning": "mandarin",
      "tags": ["food", "fruits"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ま",
        "か"
      ]
    },
    "tomato": {
      "jp_character": "トマト",
      "romanji": [
        "tomato"
      ],
      "sound": "トマト",
      "meaning": "tomato",
      "tags": ["food", "vegetables"],
      "katakana_groups": [
        "マ",
        "タ"
      ],
      "hiragana_groups": []
    },
    "sushi": {
      "jp_character": "すし",
      "romanji": [
        "sushi"
      ],
      "sound": "すし",
      "meaning": "sushi",
      "tags": ["food", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "さ"
      ]
    },
    "ramen": {
      "jp_character": "ラーメン",
      "romanji": [
        "ramen",
        "raamen"
      ],
      "sound": "ラーメン",
      "meaning": "ramen",
      "tags": ["food", "japanese_culture"],
      "katakana_groups": [
        "マ",
        "ラ",
        "ワ"
      ],
      "hiragana_groups": []
    },
    "udon": {
      "jp_character": "うどん",
      "romanji": [
        "udon"
      ],
      "sound": "うどん",
      "meaning": "udon noodles",
      "tags": ["food", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "あ",
        "だ"
      ]
    },
    "soba": {
      "jp_character": "そば",
      "romanji": [
        "soba"
      ],
      "sound": "そば",
      "meaning": "soba noodles",
      "tags": ["food", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "さ"
      ]
    },
    "karee raisu": {
      "jp_character": "カレーライス",
      "romanji": [
        "karee raisu",
        "kareeraisu"
      ],
      "sound": "カレーライス",
      "meaning": "curry rice",
      "tags": ["basic"],
      "katakana_groups": [
        "サ",
        "ラ",
        "ア",
        "カ"
      ],
      "hiragana_groups": []
    },
    "yasai": {
      "jp_character": "やさい",
      "romanji": [
        "yasai"
      ],
      "sound": "やさい",
      "meaning": "vegetable",
      "tags": ["food", "vegetables"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "さ"
      ]
    },
    "tamago": {
      "jp_character": "たまご",
      "romanji": [
        "tamago"
      ],
      "sound": "たまご",
      "meaning": "egg",
      "tags": ["food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "た",
        "が"
      ]
    },
    "kudamono": {
      "jp_character": "くだもの",
      "romanji": [
        "kudamono"
      ],
      "sound": "くだもの",
      "meaning": "fruit",
      "tags": ["food", "fruits"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "か",
        "だ",
        "な"
      ]
    },
    "okashi": {
      "jp_character": "おかし",
      "romanji": [
        "okashi"
      ],
      "sound": "おかし",
      "meaning": "candy",
      "tags": ["food", "sweets"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "さ"
      ]
    },
    "keeki": {
      "jp_character": "ケーキ",
      "romanji": [
        "keeki"
      ],
      "sound": "ケーキ",
      "meaning": "cake",
      "tags": ["food", "sweets"],
      "katakana_groups": [
        "カ"
      ],
      "hiragana_groups": []
    },
    "aisukurimu": {
      "jp_character": "アイスクリーム",
      "romanji": [
        "aisukurimu",
        "aisukuriimu"
      ],
      "sound": "アイスクリーム",
      "meaning": "ice cream",
      "tags": ["food", "sweets"],
      "katakana_groups": [
        "ラ",
        "カ",
        "マ",
        "サ",
        "ア"
      ],
      "hiragana_groups": []
    },
    "misoshiru": {
      "jp_character": "みそしる",
      "romanji": [
        "misoshiru"
      ],
      "sound": "みそしる",
      "meaning": "miso soup",
      "tags": ["food", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "ま",
        "さ"
      ]
    },
    "tonjiru": {
      "jp_character": "とんじる",
      "romanji": [
        "tonjiru"
      ],
      "sound": "とんじる",
      "meaning": "pork miso soup",
      "tags": ["food", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ら",
        "た",
        "ざ"
      ]
    },
    "suupu": {
      "jp_character": "スープ",
      "romanji": [
        "suupu"
      ],
      "sound": "スープ",
      "meaning": "soup",
      "tags": ["food"],
      "katakana_groups": [
        "サ",
        "パ"
      ],
      "hiragana_groups": []
    },
    "pasta": {
      "jp_character": "パスタ",
      "romanji": [
        "pasta",
        "pasuta"
      ],
      "sound": "パスタ",
      "meaning": "pasta",
      "tags": ["food"],
      "katakana_groups": [
        "サ",
        "タ",
        "パ"
      ],
      "hiragana_groups": []
    },
    "omuretsu": {
      "jp_character": "オムレツ",
      "romanji": [
        "omuretsu"
      ],
      "sound": "オムレツ",
      "meaning": "omelette",
      "tags": ["food"],
      "katakana_groups": [
        "マ",
        "ラ",
        "タ",
        "ア"
      ],
      "hiragana_groups": []
    },
    "nudoru": {
      "jp_character": "ヌードル",
      "romanji": [
        "nudoru",
        "nuudoru"
      ],
      "sound": "ヌードル",
      "meaning": "noodles",
      "tags": ["food"],
      "katakana_groups": [
        "ナ",
        "ダ",
        "ラ"
      ],
      "hiragana_groups": []
    },
    "gyuudon": {
      "jp_character": "ぎゅうどん",
      "romanji": [
        "gyuudon",
        "gyudon"
      ],
      "sound": "ぎゅうどん",
      "meaning": "beef bowl",
      "tags": ["food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "だ",
        "や",
        "あ",
        "わ",
        "が"
      ]
    },
    "katsudon": {
      "jp_character": "かつどん",
      "romanji": [
        "katsudon"
      ],
      "sound": "かつどん",
      "meaning": "pork cutlet bowl",
      "tags": ["food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "か",
        "だ",
        "た"
      ]
    },
    "tempura": {
      "jp_character": "てんぷら",
      "romanji": [
        "tempura",
        "tenpura"
      ],
      "sound": "てんぷら",
      "meaning": "tempura",
      "tags": ["food", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ぱ",
        "ら",
        "た"
      ]
    },
    "tendon": {
      "jp_character": "てんどん",
      "romanji": [
        "tendon"
      ],
      "sound": "てんどん",
      "meaning": "tempura bowl",
      "tags": ["food", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "だ",
        "た"
      ]
    },
    "ebifurai": {
      "jp_character": "えびふらい",
      "romanji": [
        "ebifurai"
      ],
      "sound": "えびふらい",
      "meaning": "fried shrimp",
      "tags": ["food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "あ",
        "ら",
        "は"
      ]
    },
    "sasakama": {
      "jp_character": "ささかま",
      "romanji": [
        "sasakama"
      ],
      "sound": "ささかま",
      "meaning": "fish cake",
      "tags": ["food", "sweets"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "か",
        "さ"
      ]
    },
    "yakisoba": {
      "jp_character": "やきそば",
      "romanji": [
        "yakisoba"
      ],
      "sound": "やきそば",
      "meaning": "fried noodles",
      "tags": ["food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ば",
        "か",
        "さ"
      ]
    },
    "yakitori": {
      "jp_character": "やきとり",
      "romanji": [
        "yakitori"
      ],
      "sound": "やきとり",
      "meaning": "grilled chicken",
      "tags": ["food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ら",
        "か",
        "た"
      ]
    },
    "okonomiyaki": {
      "jp_character": "おこのみやき",
      "romanji": [
        "okonomiyaki"
      ],
      "sound": "おこのみやき",
      "meaning": "savory pancake",
      "tags": ["food", "sweets"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "や",
        "あ",
        "か",
        "な"
      ]
    },
    "mitsu": {
      "jp_character": "みつ",
      "romanji": [
        "mitsu"
      ],
      "sound": "みつ",
      "meaning": "honey",
      "tags": ["food", "sweets"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "た"
      ]
    },
    "ankooru": {
      "jp_character": "アンコール",
      "romanji": [
        "ankooru"
      ],
      "sound": "アンコール",
      "meaning": "encore",
      "tags": ["entertainment", "music"],
      "katakana_groups": [
        "ワ",
        "カ",
        "ラ",
        "ア"
      ],
      "hiragana_groups": []
    },
    "ramune": {
      "jp_character": "ラムネ",
      "romanji": [
        "ramune"
      ],
      "sound": "ラムネ",
      "meaning": "Ramune (soda)",
      "tags": ["food", "drinks"],
      "katakana_groups": [
        "ナ",
        "マ",
        "ラ"
      ],
      "hiragana_groups": []
    },
    "biru": {
      "jp_character": "ビル",
      "romanji": [
        "biru"
      ],
      "sound": "ビル",
      "meaning": "building",
      "tags": ["places", "buildings"],
      "katakana_groups": [
        "バ",
        "ラ"
      ],
      "hiragana_groups": []
    },
    "tougarashi": {
      "jp_character": "とうがらし",
      "romanji": [
        "tougarashi"
      ],
      "sound": "とうがらし",
      "meaning": "chili pepper",
      "tags": ["food", "vegetables"],
      "katakana_groups": [],
      "hiragana_groups": [
        "た",
        "ら",
        "あ",
        "さ",
        "が"
      ]
    },
    "shio": {
      "jp_character": "しお",
      "romanji": [
        "shio"
      ],
      "sound": "しお",
      "meaning": "salt",
      "tags": ["food", "condiments"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "さ"
      ]
    },
    "koshou": {
      "jp_character": "こしょう",
      "romanji": [
        "koshou"
      ],
      "sound": "こしょう",
      "meaning": "black pepper",
      "tags": ["food", "vegetables"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "か",
        "さ"
      ]
    },
    "shouyu": {
      "jp_character": "しょうゆ",
      "romanji": [
        "shouyu"
      ],
      "sound": "しょうゆ",
      "meaning": "soy sauce",
      "tags": ["food", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "さ"
      ]
    },
    "tonkatsu sosu": {
      "jp_character": "とんかつソース",
      "romanji": [
        "tonkatsu sosu",
        "tonkatsusoosu"
      ],
      "sound": "とんかつソース",
      "meaning": "tonkatsu sauce",
      "tags": ["food", "condiments"],
      "katakana_groups": [
        "サ"
      ],
      "hiragana_groups": [
        "わ",
        "か",
        "た"
      ]
    },
    "mayone-zu": {
      "jp_character": "マヨネーズ",
      "romanji": [
        "mayone-zu",
        "mayoneezu"
      ],
      "sound": "マヨネーズ",
      "meaning": "mayonnaise",
      "tags": ["food", "condiments"],
      "katakana_groups": [
        "ナ",
        "ザ",
        "マ",
        "ヤ"
      ],
      "hiragana_groups": []
    },
    "karashi": {
      "jp_character": "からし",
      "romanji": [
        "karashi"
      ],
      "sound": "からし",
      "meaning": "mustard",
      "tags": ["food", "condiments"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "か",
        "さ"
      ]
    },
    "wasabi": {
      "jp_character": "わさび",
      "romanji": [
        "wasabi"
      ],
      "sound": "わさび",
      "meaning": "wasabi",
      "tags": ["food", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ば",
        "さ"
      ]
    },
    "kabocha": {
      "jp_character": "かぼちゃ",
      "romanji": [
        "kabocha"
      ],
      "sound": "かぼちゃ",
      "meaning": "pumpkin",
      "tags": ["food", "vegetables"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ば",
        "か",
        "た"
      ]
    },
    "nasu": {
      "jp_character": "なす",
      "romanji": [
        "nasu"
      ],
      "sound": "なす",
      "meaning": "eggplant",
      "tags": ["food", "vegetables"],
      "katakana_groups": [],
      "hiragana_groups": [
        "さ",
        "な"
      ]
    },
    "pi-man": {
      "jp_character": "ピーマン",
      "romanji": [
        "pi-man",
        "piiman"
      ],
      "sound": "ピーマン",
      "meaning": "green pepper",
      "tags": ["food", "vegetables"],
      "katakana_groups": [
        "マ",
        "ワ",
        "パ"
      ],
      "hiragana_groups": []
    },
    "papurika": {
      "jp_character": "パプリカ",
      "romanji": [
        "papurika"
      ],
      "sound": "パプリカ",
      "meaning": "bell pepper",
      "tags": ["food", "vegetables"],
      "katakana_groups": [
        "カ",
        "ラ",
        "パ"
      ],
      "hiragana_groups": []
    },
    "rena": {
      "jp_character": "レナ",
      "romanji": [
        "rena"
      ],
      "sound": "レナ",
      "meaning": "lettuce",
      "tags": ["food", "vegetables"],
      "katakana_groups": [
        "ナ",
        "ラ"
      ],
      "hiragana_groups": []
    },
    "bacon": {
      "jp_character": "ベーコン",
      "romanji": [
        "bacon",
        "beekon"
      ],
      "sound": "ベーコン",
      "meaning": "bacon",
      "tags": ["food", "meat"],
      "katakana_groups": [
        "バ",
        "ワ",
        "カ"
      ],
      "hiragana_groups": []
    },
    "hamu": {
      "jp_character": "ハム",
      "romanji": [
        "hamu"
      ],
      "sound": "ハム",
      "meaning": "ham",
      "tags": ["food", "meat"],
      "katakana_groups": [
        "マ",
        "ハ"
      ],
      "hiragana_groups": []
    },
    "chiken": {
      "jp_character": "チキン",
      "romanji": [
        "chiken",
        "chikin"
      ],
      "sound": "チキン",
      "meaning": "chicken",
      "tags": ["food"],
      "katakana_groups": [
        "ワ",
        "タ",
        "カ"
      ],
      "hiragana_groups": []
    },
    "nan": {
      "jp_character": "パン",
      "romanji": [
        "nan",
        "pan"
      ],
      "sound": "パン",
      "meaning": "bread",
      "tags": ["food"],
      "katakana_groups": [
        "ワ",
        "パ"
      ],
      "hiragana_groups": []
    },
    "piza": {
      "jp_character": "ピザ",
      "romanji": [
        "piza"
      ],
      "sound": "ピザ",
      "meaning": "pizza",
      "tags": ["food"],
      "katakana_groups": [
        "ザ",
        "パ"
      ],
      "hiragana_groups": []
    },
    "pasuta": {
      "jp_character": "パスタ",
      "romanji": [
        "pasuta"
      ],
      "sound": "パスタ",
      "meaning": "pasta",
      "tags": ["food"],
      "katakana_groups": [
        "サ",
        "タ",
        "パ"
      ],
      "hiragana_groups": []
    },
    "akachan": {
      "jp_character": "あかちゃん",
      "romanji": [
        "akachan"
      ],
      "sound": "あかちゃん",
      "meaning": "baby",
      "tags": ["people", "family"],
      "katakana_groups": [],
      "hiragana_groups": [
        "た",
        "や",
        "あ",
        "か",
        "わ"
      ]
    },
    "akai": {
      "jp_character": "あかい",
      "romanji": [
        "akai"
      ],
      "sound": "あかい",
      "meaning": "red",
      "tags": ["colors", "adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か"
      ]
    },
    "akarui": {
      "jp_character": "あかるい",
      "romanji": [
        "akarui"
      ],
      "sound": "あかるい",
      "meaning": "bright",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "か"
      ]
    },
    "arigatou": {
      "jp_character": "ありがとう",
      "romanji": [
        "arigatou"
      ],
      "sound": "ありがとう",
      "meaning": "thank you",
      "tags": ["expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "た",
        "が"
      ]
    },
    "banana": {
      "jp_character": "バナナ",
      "romanji": [
        "banana"
      ],
      "sound": "バナナ",
      "meaning": "banana",
      "tags": ["food", "fruits"],
      "katakana_groups": [
        "バ",
        "ナ"
      ],
      "hiragana_groups": []
    },
    "bikkuri": {
      "jp_character": "びっくり",
      "romanji": [
        "bikkuri"
      ],
      "sound": "びっくり",
      "meaning": "surprise",
      "tags": ["feelings", "expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "ば",
        "か",
        "た"
      ]
    },
    "bosu": {
      "jp_character": "ボス",
      "romanji": [
        "bosu"
      ],
      "sound": "ボス",
      "meaning": "boss",
      "tags": ["people", "work"],
      "katakana_groups": [
        "バ",
        "サ"
      ],
      "hiragana_groups": []
    },
    "burokkori": {
      "jp_character": "ぶろっこり",
      "romanji": [
        "burokkori"
      ],
      "sound": "ぶろっこり",
      "meaning": "plump",
      "tags": ["basic"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "ば",
        "か",
        "た"
      ]
    },
    "busu": {
      "jp_character": "ブス",
      "romanji": [
        "busu"
      ],
      "sound": "ブス",
      "meaning": "ugly",
      "tags": ["adjectives", "appearance"],
      "katakana_groups": [
        "バ",
        "サ"
      ],
      "hiragana_groups": []
    },
    "byouin": {
      "jp_character": "びょういん",
      "romanji": [
        "byouin"
      ],
      "sound": "びょういん",
      "meaning": "hospital",
      "tags": ["places", "health"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ば",
        "わ",
        "あ"
      ]
    },
    "cha": {
      "jp_character": "ちゃ",
      "romanji": [
        "cha"
      ],
      "sound": "ちゃ",
      "meaning": "tea",
      "tags": ["food", "drinks"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "た"
      ]
    },
    "chotto": {
      "jp_character": "ちょっと",
      "romanji": [
        "chotto"
      ],
      "sound": "ちょっと",
      "meaning": "a little",
      "tags": ["adverbs", "expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "た"
      ]
    },
    "densha": {
      "jp_character": "でんしゃ",
      "romanji": [
        "densha"
      ],
      "sound": "でんしゃ",
      "meaning": "train",
      "tags": ["transportation"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "や",
        "だ",
        "さ"
      ]
    },
    "doa": {
      "jp_character": "ドア",
      "romanji": [
        "doa"
      ],
      "sound": "ドア",
      "meaning": "door",
      "tags": ["home", "items"],
      "katakana_groups": [
        "ダ",
        "ア"
      ],
      "hiragana_groups": []
    },
    "dokodemo": {
      "jp_character": "どこでも",
      "romanji": [
        "dokodemo"
      ],
      "sound": "どこでも",
      "meaning": "anywhere",
      "tags": ["question_words"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "か",
        "だ"
      ]
    },
    "dore": {
      "jp_character": "どれ",
      "romanji": [
        "dore"
      ],
      "sound": "どれ",
      "meaning": "which one",
      "tags": ["question_words"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "だ"
      ]
    },
    "e": {
      "jp_character": "え",
      "romanji": [
        "e"
      ],
      "sound": "え",
      "meaning": "picture",
      "tags": ["basic"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ"
      ]
    },
    "fuyu": {
      "jp_character": "ふゆ",
      "romanji": [
        "fuyu"
      ],
      "sound": "ふゆ",
      "meaning": "winter",
      "tags": ["seasons", "time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "は"
      ]
    },
    "ginkou": {
      "jp_character": "ぎんこう",
      "romanji": [
        "ginkou"
      ],
      "sound": "ぎんこう",
      "meaning": "bank",
      "tags": ["places", "money"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "あ",
        "か",
        "が"
      ]
    },
    "gomen": {
      "jp_character": "ごめん",
      "romanji": [
        "gomen"
      ],
      "sound": "ごめん",
      "meaning": "sorry",
      "tags": ["expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ま",
        "が"
      ]
    },
    "ha": {
      "jp_character": "は",
      "romanji": [
        "ha"
      ],
      "sound": "は",
      "meaning": "tooth",
      "tags": ["body_parts"],
      "katakana_groups": [],
      "hiragana_groups": [
        "は"
      ]
    },
    "hai": {
      "jp_character": "はい",
      "romanji": [
        "hai"
      ],
      "sound": "はい",
      "meaning": "yes",
      "tags": ["expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "は"
      ]
    },
    "haru": {
      "jp_character": "はる",
      "romanji": [
        "haru"
      ],
      "sound": "はる",
      "meaning": "spring",
      "tags": ["seasons", "time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "は"
      ]
    },
    "hashi": {
      "jp_character": "はし",
      "romanji": [
        "hashi"
      ],
      "sound": "はし",
      "meaning": "chopsticks",
      "tags": ["items", "food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "さ",
        "は"
      ]
    },
    "hikouki": {
      "jp_character": "ひこうき",
      "romanji": [
        "hikouki"
      ],
      "sound": "ひこうき",
      "meaning": "airplane",
      "tags": ["transportation"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "は"
      ]
    },
    "himawari": {
      "jp_character": "ひまわり",
      "romanji": [
        "himawari"
      ],
      "sound": "ひまわり",
      "meaning": "sunflower",
      "tags": ["nature", "flowers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ら",
        "ま",
        "は"
      ]
    },
    "ii": {
      "jp_character": "いい",
      "romanji": [
        "ii"
      ],
      "sound": "いい",
      "meaning": "good",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ"
      ]
    },
    "iie": {
      "jp_character": "いいえ",
      "romanji": [
        "iie"
      ],
      "sound": "いいえ",
      "meaning": "no",
      "tags": ["expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ"
      ]
    },
    "oomizu": {
      "jp_character": "おおみず",
      "romanji": [
        "oomizu"
      ],
      "sound": "おおみず",
      "meaning": "water",
      "tags": ["food", "drinks"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "ま",
        "ざ"
      ]
    },
    "sake": {
      "jp_character": "さけ",
      "romanji": [
        "sake"
      ],
      "sound": "さけ",
      "meaning": "alcohol",
      "tags": ["basic"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か",
        "さ"
      ]
    },
    "wan": {
      "jp_character": "わん",
      "romanji": [
        "wan"
      ],
      "sound": "わん",
      "meaning": "dog",
      "tags": ["animals", "pets"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ"
      ]
    },
    "neko": {
      "jp_character": "ねこ",
      "romanji": [
        "neko"
      ],
      "sound": "ねこ",
      "meaning": "cat",
      "tags": ["animals", "pets"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か",
        "な"
      ]
    },
    "tori": {
      "jp_character": "とり",
      "romanji": [
        "tori"
      ],
      "sound": "とり",
      "meaning": "bird",
      "tags": ["animals"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "た"
      ]
    },
    "uma": {
      "jp_character": "うま",
      "romanji": [
        "uma"
      ],
      "sound": "うま",
      "meaning": "horse",
      "tags": ["animals"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "ま"
      ]
    },
    "hitsuji": {
      "jp_character": "ひつじ",
      "romanji": [
        "hitsuji"
      ],
      "sound": "ひつじ",
      "meaning": "sheep",
      "tags": ["animals"],
      "katakana_groups": [],
      "hiragana_groups": [
        "た",
        "は",
        "ざ"
      ]
    },
    "buta": {
      "jp_character": "ぶた",
      "romanji": [
        "buta"
      ],
      "sound": "ぶた",
      "meaning": "pig",
      "tags": ["animals"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "た"
      ]
    },
    "inoshishi": {
      "jp_character": "いのしし",
      "romanji": [
        "inoshishi"
      ],
      "sound": "いのしし",
      "meaning": "boar",
      "tags": ["basic"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "さ",
        "な"
      ]
    },
    "zarigani": {
      "jp_character": "ざりがに",
      "romanji": [
        "zarigani"
      ],
      "sound": "ざりがに",
      "meaning": "crab",
      "tags": ["basic"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "な",
        "ざ",
        "が"
      ]
    },
    "ika": {
      "jp_character": "いか",
      "romanji": [
        "ika"
      ],
      "sound": "いか",
      "meaning": "squid",
      "tags": ["animals", "seafood"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か"
      ]
    },
    "ebi": {
      "jp_character": "えび",
      "romanji": [
        "ebi"
      ],
      "sound": "えび",
      "meaning": "shrimp",
      "tags": ["food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "あ"
      ]
    },
    "momo": {
      "jp_character": "もも",
      "romanji": [
        "momo"
      ],
      "sound": "もも",
      "meaning": "peach",
      "tags": ["food", "fruits"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま"
      ]
    },
    "budou": {
      "jp_character": "ぶどう",
      "romanji": [
        "budou"
      ],
      "sound": "ぶどう",
      "meaning": "grape",
      "tags": ["food", "fruits"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "だ",
        "あ"
      ]
    },
    "ichigo": {
      "jp_character": "いちご",
      "romanji": [
        "ichigo"
      ],
      "sound": "いちご",
      "meaning": "strawberry",
      "tags": ["food", "fruits"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "た",
        "が"
      ]
    },
    "kurisumasu": {
      "jp_character": "クリスマス",
      "romanji": [
        "kurisumasu"
      ],
      "sound": "クリスマス",
      "meaning": "Christmas",
      "tags": ["events", "holidays"],
      "katakana_groups": [
        "サ",
        "マ",
        "ラ",
        "カ"
      ],
      "hiragana_groups": []
    },
    "hanabi": {
      "jp_character": "はなび",
      "romanji": [
        "hanabi"
      ],
      "sound": "はなび",
      "meaning": "fireworks",
      "tags": ["events", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "は",
        "な"
      ]
    },
    "hina": {
      "jp_character": "ひな",
      "romanji": [
        "hina"
      ],
      "sound": "ひな",
      "meaning": "doll",
      "tags": ["items", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "は",
        "な"
      ]
    },
    "tanjoubi": {
      "jp_character": "たんじょうび",
      "romanji": [
        "tanjoubi"
      ],
      "sound": "たんじょうび",
      "meaning": "birthday",
      "tags": ["events", "celebrations"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "た",
        "ざ",
        "や",
        "あ",
        "わ"
      ]
    },
    "kyou": {
      "jp_character": "きょう",
      "romanji": [
        "kyou"
      ],
      "sound": "きょう",
      "meaning": "today",
      "tags": ["time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "か"
      ]
    },
    "ashita": {
      "jp_character": "あした",
      "romanji": [
        "ashita"
      ],
      "sound": "あした",
      "meaning": "tomorrow",
      "tags": ["time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "さ",
        "た"
      ]
    },
    "kinou": {
      "jp_character": "きのう",
      "romanji": [
        "kinou"
      ],
      "sound": "きのう",
      "meaning": "yesterday",
      "tags": ["expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "な"
      ]
    },
    "getsuyoubi": {
      "jp_character": "げつようび",
      "romanji": [
        "getsuyoubi"
      ],
      "sound": "げつようび",
      "meaning": "Monday",
      "tags": ["time", "days_of_week"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "た",
        "や",
        "あ",
        "が"
      ]
    },
    "kayoubi": {
      "jp_character": "かようび",
      "romanji": [
        "kayoubi"
      ],
      "sound": "かようび",
      "meaning": "Tuesday",
      "tags": ["time", "days_of_week"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ば",
        "あ",
        "か"
      ]
    },
    "suiyoubi": {
      "jp_character": "すいようび",
      "romanji": [
        "suiyoubi"
      ],
      "sound": "すいようび",
      "meaning": "Wednesday",
      "tags": ["time", "days_of_week"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ば",
        "あ",
        "さ"
      ]
    },
    "mokuyoubi": {
      "jp_character": "もくようび",
      "romanji": [
        "mokuyoubi"
      ],
      "sound": "もくようび",
      "meaning": "Thursday",
      "tags": ["time", "days_of_week"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "ま",
        "や",
        "あ",
        "か"
      ]
    },
    "kinyoubi": {
      "jp_character": "きんようび",
      "romanji": [
        "kinyoubi",
        "kin'youbi"
      ],
      "sound": "きんようび",
      "meaning": "Friday",
      "tags": ["time", "days_of_week"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "や",
        "あ",
        "か",
        "わ"
      ]
    },
    "doyoubi": {
      "jp_character": "どようび",
      "romanji": [
        "doyoubi"
      ],
      "sound": "どようび",
      "meaning": "Saturday",
      "tags": ["time", "days_of_week"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ば",
        "あ",
        "だ"
      ]
    },
    "nichiyoubi": {
      "jp_character": "にちようび",
      "romanji": [
        "nichiyoubi"
      ],
      "sound": "にちようび",
      "meaning": "Sunday",
      "tags": ["time", "days_of_week"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "た",
        "や",
        "あ",
        "な"
      ]
    },
    "natsu": {
      "jp_character": "なつ",
      "romanji": [
        "natsu"
      ],
      "sound": "なつ",
      "meaning": "summer",
      "tags": ["seasons", "time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "た",
        "な"
      ]
    },
    "aki": {
      "jp_character": "あき",
      "romanji": [
        "aki"
      ],
      "sound": "あき",
      "meaning": "autumn",
      "tags": ["seasons", "time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か"
      ]
    },
    "kouen": {
      "jp_character": "こうえん",
      "romanji": [
        "kouen"
      ],
      "sound": "こうえん",
      "meaning": "park",
      "tags": ["places", "nature"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "あ",
        "か"
      ]
    },
    "gakkou": {
      "jp_character": "がっこう",
      "romanji": [
        "gakkou"
      ],
      "sound": "がっこう",
      "meaning": "school",
      "tags": ["places", "education"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "た",
        "が"
      ]
    },
    "daigaku": {
      "jp_character": "だいがく",
      "romanji": [
        "daigaku"
      ],
      "sound": "だいがく",
      "meaning": "university",
      "tags": ["places", "education"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "だ",
        "が"
      ]
    },
    "chuugakkou": {
      "jp_character": "ちゅうがっこう",
      "romanji": [
        "chuugakkou"
      ],
      "sound": "ちゅうがっこう",
      "meaning": "middle school",
      "tags": ["places", "education"],
      "katakana_groups": [],
      "hiragana_groups": [
        "た",
        "や",
        "あ",
        "か",
        "が"
      ]
    },
    "shougakkou": {
      "jp_character": "しょうがっこう",
      "romanji": [
        "shougakkou"
      ],
      "sound": "しょうがっこう",
      "meaning": "elementary school",
      "tags": ["places", "education"],
      "katakana_groups": [],
      "hiragana_groups": [
        "た",
        "や",
        "あ",
        "か",
        "さ",
        "が"
      ]
    },
    "hoteru": {
      "jp_character": "ホテル",
      "romanji": [
        "hoteru"
      ],
      "sound": "ホテル",
      "meaning": "hotel",
      "tags": ["adjectives"],
      "katakana_groups": [
        "タ",
        "ラ",
        "ハ"
      ],
      "hiragana_groups": []
    },
    "misosiru": {
      "jp_character": "みそしる",
      "romanji": [
        "misosiru",
        "misoshiru"
      ],
      "sound": "みそしる",
      "meaning": "miso soup",
      "tags": ["food", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "ま",
        "さ"
      ]
    },
    "toire": {
      "jp_character": "トイレ",
      "romanji": [
        "toire"
      ],
      "sound": "トイレ",
      "meaning": "toilet",
      "tags": ["places", "home"],
      "katakana_groups": [
        "タ",
        "ラ",
        "ア"
      ],
      "hiragana_groups": []
    },
    "denwa": {
      "jp_character": "でんわ",
      "romanji": [
        "denwa"
      ],
      "sound": "でんわ",
      "meaning": "phone",
      "tags": ["items", "communication"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "だ"
      ]
    },
    "terebi": {
      "jp_character": "テレビ",
      "romanji": [
        "terebi"
      ],
      "sound": "テレビ",
      "meaning": "television",
      "tags": ["items", "entertainment"],
      "katakana_groups": [
        "バ",
        "タ",
        "ラ"
      ],
      "hiragana_groups": []
    },
    "kuruma": {
      "jp_character": "くるま",
      "romanji": [
        "kuruma"
      ],
      "sound": "くるま",
      "meaning": "car",
      "tags": ["transportation"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "ら",
        "か"
      ]
    },
    "fune": {
      "jp_character": "ふね",
      "romanji": [
        "fune"
      ],
      "sound": "ふね",
      "meaning": "ship",
      "tags": ["transportation"],
      "katakana_groups": [],
      "hiragana_groups": [
        "は",
        "な"
      ]
    },
    "jitensha": {
      "jp_character": "じてんしゃ",
      "romanji": [
        "jitensha"
      ],
      "sound": "じてんしゃ",
      "meaning": "bicycle",
      "tags": ["transportation"],
      "katakana_groups": [],
      "hiragana_groups": [
        "た",
        "ざ",
        "や",
        "わ",
        "さ"
      ]
    },
    "aruki": {
      "jp_character": "あるき",
      "romanji": [
        "aruki"
      ],
      "sound": "あるき",
      "meaning": "walking",
      "tags": ["movement", "verbs"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "か"
      ]
    },
    "sara": {
      "jp_character": "さら",
      "romanji": [
        "sara"
      ],
      "sound": "さら",
      "meaning": "plate",
      "tags": ["items", "food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "さ"
      ]
    },
    "ryokan": {
      "jp_character": "りょかん",
      "romanji": [
        "ryokan"
      ],
      "sound": "りょかん",
      "meaning": "Japanese inn",
      "tags": ["places", "travel", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ら",
        "か",
        "わ"
      ]
    },
    "sentou": {
      "jp_character": "せんとう",
      "romanji": [
        "sentou"
      ],
      "sound": "せんとう",
      "meaning": "public bath",
      "tags": ["places", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "あ",
        "さ",
        "た"
      ]
    },
    "onsen": {
      "jp_character": "おんせん",
      "romanji": [
        "onsen"
      ],
      "sound": "おんせん",
      "meaning": "hot spring",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "あ",
        "さ"
      ]
    },
    "otaku": {
      "jp_character": "オタク",
      "romanji": [
        "otaku"
      ],
      "sound": "オタク",
      "meaning": "geek",
      "tags": ["basic"],
      "katakana_groups": [
        "カ",
        "タ",
        "ア"
      ],
      "hiragana_groups": []
    },
    "manga": {
      "jp_character": "まんが",
      "romanji": [
        "manga"
      ],
      "sound": "まんが",
      "meaning": "manga",
      "tags": ["entertainment", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ま",
        "が"
      ]
    },
    "anime": {
      "jp_character": "アニメ",
      "romanji": [
        "anime"
      ],
      "sound": "アニメ",
      "meaning": "anime",
      "tags": ["entertainment", "japanese_culture"],
      "katakana_groups": [
        "ナ",
        "マ",
        "ア"
      ],
      "hiragana_groups": []
    },
    "sumo": {
      "jp_character": "すもう",
      "romanji": [
        "sumo",
        "sumou"
      ],
      "sound": "すもう",
      "meaning": "sumo",
      "tags": ["sports", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "ま",
        "さ"
      ]
    },
    "chanoyu": {
      "jp_character": "ちゃのゆ",
      "romanji": [
        "chanoyu"
      ],
      "sound": "ちゃのゆ",
      "meaning": "tea ceremony",
      "tags": ["food", "drinks"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "た",
        "な"
      ]
    },
    "ikebana": {
      "jp_character": "いけばな",
      "romanji": [
        "ikebana"
      ],
      "sound": "いけばな",
      "meaning": "flower arrangement",
      "tags": ["activities", "japanese_culture", "art"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "あ",
        "か",
        "な"
      ]
    },
    "bonsai": {
      "jp_character": "ぼんさい",
      "romanji": [
        "bonsai"
      ],
      "sound": "ぼんさい",
      "meaning": "bonsai",
      "tags": ["hobbies", "nature", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ば",
        "さ",
        "あ"
      ]
    },
    "kabuki": {
      "jp_character": "かぶき",
      "romanji": [
        "kabuki"
      ],
      "sound": "かぶき",
      "meaning": "Japanese theatre form",
      "tags": ["basic"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "か"
      ]
    },
    "origami": {
      "jp_character": "おりがみ",
      "romanji": [
        "origami"
      ],
      "sound": "おりがみ",
      "meaning": "origami",
      "tags": ["activities", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "ま",
        "が"
      ]
    },
    "shamisen": {
      "jp_character": "しゃみせん",
      "romanji": [
        "shamisen"
      ],
      "sound": "しゃみせん",
      "meaning": "Japanese string instrument",
      "tags": ["basic"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ま",
        "さ",
        "わ"
      ]
    },
    "furoshiki": {
      "jp_character": "ふろしき",
      "romanji": [
        "furoshiki"
      ],
      "sound": "ふろしき",
      "meaning": "traditional wrapping cloths",
      "tags": ["items", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "か",
        "さ",
        "は"
      ]
    },
    "ukiyoe": {
      "jp_character": "うきよえ",
      "romanji": [
        "ukiyoe"
      ],
      "sound": "うきよえ",
      "meaning": "ukiyoe (art genre)",
      "tags": ["basic"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "か"
      ]
    },
    "katana": {
      "jp_character": "かたな",
      "romanji": [
        "katana"
      ],
      "sound": "かたな",
      "meaning": "sword",
      "tags": ["items", "weapons", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か",
        "た",
        "な"
      ]
    },
    "judo": {
      "jp_character": "じゅどう",
      "romanji": [
        "judo",
        "judou"
      ],
      "sound": "じゅどう",
      "meaning": "judo (martial art)",
      "tags": ["sports", "martial_arts", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "だ",
        "ざ"
      ]
    },
    "karate": {
      "jp_character": "からて",
      "romanji": [
        "karate"
      ],
      "sound": "からて",
      "meaning": "karate",
      "tags": ["sports", "martial_arts", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "か",
        "た"
      ]
    },
    "aikido": {
      "jp_character": "あいきどう",
      "romanji": [
        "aikido",
        "aikidou"
      ],
      "sound": "あいきどう",
      "meaning": "Japanese martial art",
      "tags": ["sports", "martial_arts", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "だ"
      ]
    },
    "kyudo": {
      "jp_character": "きゅうどう",
      "romanji": [
        "kyudo",
        "kyuudou"
      ],
      "sound": "きゅうどう",
      "meaning": "Japanese archery",
      "tags": ["sports", "martial_arts", "japanese_culture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "か",
        "だ"
      ]
    },
    "fugu": {
      "jp_character": "ふぐ",
      "romanji": [
        "fugu"
      ],
      "sound": "ふぐ",
      "meaning": "blowfish",
      "tags": ["animals", "food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "は",
        "が"
      ]
    },
    "iku": {
      "jp_character": "いく",
      "romanji": [
        "iku"
      ],
      "sound": "いく",
      "meaning": "to go",
      "tags": ["verbs", "movement"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か"
      ]
    },
    "kuru": {
      "jp_character": "くる",
      "romanji": [
        "kuru"
      ],
      "sound": "くる",
      "meaning": "to come",
      "tags": ["verbs", "movement"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "か"
      ]
    },
    "miru": {
      "jp_character": "みる",
      "romanji": [
        "miru"
      ],
      "sound": "みる",
      "meaning": "to see",
      "tags": ["verbs", "senses"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "ら"
      ]
    },
    "kiku": {
      "jp_character": "きく",
      "romanji": [
        "kiku"
      ],
      "sound": "きく",
      "meaning": "to listen/ask",
      "tags": ["verbs", "senses"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か"
      ]
    },
    "hanasu": {
      "jp_character": "はなす",
      "romanji": [
        "hanasu"
      ],
      "sound": "はなす",
      "meaning": "to speak",
      "tags": ["verbs", "communication"],
      "katakana_groups": [],
      "hiragana_groups": [
        "は",
        "な",
        "さ"
      ]
    },
    "yomu": {
      "jp_character": "よむ",
      "romanji": [
        "yomu"
      ],
      "sound": "よむ",
      "meaning": "to read",
      "tags": ["verbs", "activities"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "や"
      ]
    },
    "kaku": {
      "jp_character": "かく",
      "romanji": [
        "kaku"
      ],
      "sound": "かく",
      "meaning": "to write",
      "tags": ["verbs", "activities"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か"
      ]
    },
    "neru": {
      "jp_character": "ねる",
      "romanji": [
        "neru"
      ],
      "sound": "ねる",
      "meaning": "to sleep",
      "tags": ["verbs", "daily_life"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "な"
      ]
    },
    "okiru": {
      "jp_character": "おきる",
      "romanji": [
        "okiru"
      ],
      "sound": "おきる",
      "meaning": "to wake up",
      "tags": ["verbs", "daily_life"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "ら",
        "か"
      ]
    },
    "au": {
      "jp_character": "あう",
      "romanji": [
        "au"
      ],
      "sound": "あう",
      "meaning": "to meet",
      "tags": ["verbs", "social"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ"
      ]
    },
    "kau": {
      "jp_character": "かう",
      "romanji": [
        "kau"
      ],
      "sound": "かう",
      "meaning": "to buy",
      "tags": ["verbs", "shopping"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か"
      ]
    },
    "uru": {
      "jp_character": "うる",
      "romanji": [
        "uru"
      ],
      "sound": "うる",
      "meaning": "to sell",
      "tags": ["verbs", "shopping"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "ら"
      ]
    },
    "tsukuru": {
      "jp_character": "つくる",
      "romanji": [
        "tsukuru"
      ],
      "sound": "つくる",
      "meaning": "to make",
      "tags": ["verbs", "activities"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "か",
        "た"
      ]
    },
    "arau": {
      "jp_character": "あらう",
      "romanji": [
        "arau"
      ],
      "sound": "あらう",
      "meaning": "to wash",
      "tags": ["verbs", "daily_life"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ"
      ]
    },
    "atama": {
      "jp_character": "あたま",
      "romanji": [
        "atama"
      ],
      "sound": "あたま",
      "meaning": "head",
      "tags": ["body_parts"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "あ",
        "た"
      ]
    },
    "me": {
      "jp_character": "め",
      "romanji": [
        "me"
      ],
      "sound": "め",
      "meaning": "eye",
      "tags": ["body_parts"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま"
      ]
    },
    "mimi": {
      "jp_character": "みみ",
      "romanji": [
        "mimi"
      ],
      "sound": "みみ",
      "meaning": "ear",
      "tags": ["body_parts"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま"
      ]
    },
    "hana": {
      "jp_character": "はな",
      "romanji": [
        "hana"
      ],
      "sound": "はな",
      "meaning": "nose",
      "tags": ["body_parts"],
      "katakana_groups": [],
      "hiragana_groups": [
        "は",
        "な"
      ]
    },
    "kuchi": {
      "jp_character": "くち",
      "romanji": [
        "kuchi"
      ],
      "sound": "くち",
      "meaning": "mouth",
      "tags": ["body_parts"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か",
        "た"
      ]
    },
    "te": {
      "jp_character": "て",
      "romanji": [
        "te"
      ],
      "sound": "て",
      "meaning": "hand",
      "tags": ["body_parts"],
      "katakana_groups": [],
      "hiragana_groups": [
        "た"
      ]
    },
    "ashi": {
      "jp_character": "あし",
      "romanji": [
        "ashi"
      ],
      "sound": "あし",
      "meaning": "foot/leg",
      "tags": ["body_parts"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "さ"
      ]
    },
    "onaka": {
      "jp_character": "おなか",
      "romanji": [
        "onaka"
      ],
      "sound": "おなか",
      "meaning": "stomach",
      "tags": ["body_parts"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "な",
        "か"
      ]
    },
    "chichi": {
      "jp_character": "ちち",
      "romanji": [
        "chichi"
      ],
      "sound": "ちち",
      "meaning": "father",
      "tags": ["family"],
      "katakana_groups": [],
      "hiragana_groups": [
        "た"
      ]
    },
    "haha": {
      "jp_character": "はは",
      "romanji": [
        "haha"
      ],
      "sound": "はは",
      "meaning": "mother",
      "tags": ["family"],
      "katakana_groups": [],
      "hiragana_groups": [
        "は"
      ]
    },
    "otouto": {
      "jp_character": "おとうと",
      "romanji": [
        "otouto"
      ],
      "sound": "おとうと",
      "meaning": "younger brother",
      "tags": ["family"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "た"
      ]
    },
    "ani": {
      "jp_character": "あに",
      "romanji": [
        "ani"
      ],
      "sound": "あに",
      "meaning": "older brother",
      "tags": ["family"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "な"
      ]
    },
    "imouto": {
      "jp_character": "いもうと",
      "romanji": [
        "imouto"
      ],
      "sound": "いもうと",
      "meaning": "younger sister",
      "tags": ["family"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "あ",
        "た"
      ]
    },
    "ane": {
      "jp_character": "あね",
      "romanji": [
        "ane"
      ],
      "sound": "あね",
      "meaning": "older sister",
      "tags": ["family"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "な"
      ]
    },
    "kodomo": {
      "jp_character": "こども",
      "romanji": [
        "kodomo"
      ],
      "sound": "こども",
      "meaning": "child",
      "tags": ["family", "people"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "だ",
        "か"
      ]
    },
    "ichi": {
      "jp_character": "いち",
      "romanji": [
        "ichi"
      ],
      "sound": "いち",
      "meaning": "one",
      "tags": ["numbers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "た"
      ]
    },
    "ni": {
      "jp_character": "に",
      "romanji": [
        "ni"
      ],
      "sound": "に",
      "meaning": "two",
      "tags": ["numbers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "な"
      ]
    },
    "san": {
      "jp_character": "さん",
      "romanji": [
        "san"
      ],
      "sound": "さん",
      "meaning": "three",
      "tags": ["numbers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "さ"
      ]
    },
    "shi": {
      "jp_character": "し",
      "romanji": [
        "shi"
      ],
      "sound": "し",
      "meaning": "four",
      "tags": ["numbers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "さ"
      ]
    },
    "go": {
      "jp_character": "ご",
      "romanji": [
        "go"
      ],
      "sound": "ご",
      "meaning": "five",
      "tags": ["numbers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "が"
      ]
    },
    "roku": {
      "jp_character": "ろく",
      "romanji": [
        "roku"
      ],
      "sound": "ろく",
      "meaning": "six",
      "tags": ["numbers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "か"
      ]
    },
    "shichi": {
      "jp_character": "しち",
      "romanji": [
        "shichi"
      ],
      "sound": "しち",
      "meaning": "seven",
      "tags": ["numbers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "さ",
        "た"
      ]
    },
    "hachi": {
      "jp_character": "はち",
      "romanji": [
        "hachi"
      ],
      "sound": "はち",
      "meaning": "eight",
      "tags": ["numbers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "は",
        "た"
      ]
    },
    "kyuu": {
      "jp_character": "きゅう",
      "romanji": [
        "kyuu"
      ],
      "sound": "きゅう",
      "meaning": "nine",
      "tags": ["numbers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "か"
      ]
    },
    "juu": {
      "jp_character": "じゅう",
      "romanji": [
        "juu"
      ],
      "sound": "じゅう",
      "meaning": "ten",
      "tags": ["numbers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "ざ"
      ]
    },
    "hyaku": {
      "jp_character": "ひゃく",
      "romanji": [
        "hyaku"
      ],
      "sound": "ひゃく",
      "meaning": "hundred",
      "tags": ["numbers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "は",
        "か"
      ]
    },
    "sen": {
      "jp_character": "せん",
      "romanji": [
        "sen"
      ],
      "sound": "せん",
      "meaning": "thousand",
      "tags": ["numbers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "さ"
      ]
    },
    "man": {
      "jp_character": "まん",
      "romanji": [
        "man"
      ],
      "sound": "まん",
      "meaning": "ten thousand",
      "tags": ["numbers"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "わ"
      ]
    },
    "shiro": {
      "jp_character": "しろ",
      "romanji": [
        "shiro"
      ],
      "sound": "しろ",
      "meaning": "white",
      "tags": ["colors"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "さ"
      ]
    },
    "kuro": {
      "jp_character": "くろ",
      "romanji": [
        "kuro"
      ],
      "sound": "くろ",
      "meaning": "black",
      "tags": ["colors"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "か"
      ]
    },
    "ao": {
      "jp_character": "あお",
      "romanji": [
        "ao"
      ],
      "sound": "あお",
      "meaning": "blue",
      "tags": ["colors"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ"
      ]
    },
    "kiiro": {
      "jp_character": "きいろ",
      "romanji": [
        "kiiro"
      ],
      "sound": "きいろ",
      "meaning": "yellow",
      "tags": ["colors"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "か"
      ]
    },
    "midori": {
      "jp_character": "みどり",
      "romanji": [
        "midori"
      ],
      "sound": "みどり",
      "meaning": "green",
      "tags": ["colors"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "ら",
        "だ"
      ]
    },
    "chairo": {
      "jp_character": "ちゃいろ",
      "romanji": [
        "chairo"
      ],
      "sound": "ちゃいろ",
      "meaning": "brown",
      "tags": ["colors"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ら",
        "あ",
        "た"
      ]
    },
    "ie": {
      "jp_character": "いえ",
      "romanji": [
        "ie"
      ],
      "sound": "いえ",
      "meaning": "house",
      "tags": ["places", "home"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ"
      ]
    },
    "heya": {
      "jp_character": "へや",
      "romanji": [
        "heya"
      ],
      "sound": "へや",
      "meaning": "room",
      "tags": ["places", "home"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "は"
      ]
    },
    "mado": {
      "jp_character": "まど",
      "romanji": [
        "mado"
      ],
      "sound": "まど",
      "meaning": "window",
      "tags": ["home"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "だ"
      ]
    },
    "tsukue": {
      "jp_character": "つくえ",
      "romanji": [
        "tsukue"
      ],
      "sound": "つくえ",
      "meaning": "desk",
      "tags": ["home", "furniture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "た"
      ]
    },
    "isu": {
      "jp_character": "いす",
      "romanji": [
        "isu"
      ],
      "sound": "いす",
      "meaning": "chair",
      "tags": ["home", "furniture"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "さ"
      ]
    },
    "beddo": {
      "jp_character": "ベッド",
      "romanji": [
        "beddo"
      ],
      "sound": "ベッド",
      "meaning": "bed",
      "tags": ["home", "furniture"],
      "katakana_groups": [
        "バ",
        "ダ"
      ],
      "hiragana_groups": []
    },
    "hon": {
      "jp_character": "ほん",
      "romanji": [
        "hon"
      ],
      "sound": "ほん",
      "meaning": "book",
      "tags": ["items", "education"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "は"
      ]
    },
    "enpitsu": {
      "jp_character": "えんぴつ",
      "romanji": [
        "enpitsu"
      ],
      "sound": "えんぴつ",
      "meaning": "pencil",
      "tags": ["items", "education"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ぱ",
        "あ",
        "た"
      ]
    },
    "kami": {
      "jp_character": "かみ",
      "romanji": [
        "kami"
      ],
      "sound": "かみ",
      "meaning": "paper",
      "tags": ["items"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "か"
      ]
    },
    "kaban": {
      "jp_character": "かばん",
      "romanji": [
        "kaban"
      ],
      "sound": "かばん",
      "meaning": "bag",
      "tags": ["items", "accessories"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ば",
        "か"
      ]
    },
    "tokei": {
      "jp_character": "とけい",
      "romanji": [
        "tokei"
      ],
      "sound": "とけい",
      "meaning": "clock/watch",
      "tags": ["items", "time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "た"
      ]
    },
    "kutsu": {
      "jp_character": "くつ",
      "romanji": [
        "kutsu"
      ],
      "sound": "くつ",
      "meaning": "shoes",
      "tags": ["clothing", "accessories"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か",
        "た"
      ]
    },
    "fuku": {
      "jp_character": "ふく",
      "romanji": [
        "fuku"
      ],
      "sound": "ふく",
      "meaning": "clothes",
      "tags": ["clothing"],
      "katakana_groups": [],
      "hiragana_groups": [
        "は",
        "か"
      ]
    },
    "zubon": {
      "jp_character": "ズボン",
      "romanji": [
        "zubon"
      ],
      "sound": "ズボン",
      "meaning": "pants",
      "tags": ["clothing"],
      "katakana_groups": [
        "ザ",
        "ワ",
        "バ"
      ],
      "hiragana_groups": []
    },
    "shatsu": {
      "jp_character": "シャツ",
      "romanji": [
        "shatsu"
      ],
      "sound": "シャツ",
      "meaning": "shirt",
      "tags": ["clothing"],
      "katakana_groups": [
        "ザ",
        "タ",
        "ヤ"
      ],
      "hiragana_groups": []
    },
    "boushi": {
      "jp_character": "ぼうし",
      "romanji": [
        "boushi"
      ],
      "sound": "ぼうし",
      "meaning": "hat",
      "tags": ["clothing", "accessories"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "あ",
        "さ"
      ]
    },
    "megane": {
      "jp_character": "めがね",
      "romanji": [
        "megane"
      ],
      "sound": "めがね",
      "meaning": "glasses",
      "tags": ["accessories"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "な",
        "が"
      ]
    },
    "ame": {
      "jp_character": "あめ",
      "romanji": [
        "ame"
      ],
      "sound": "あめ",
      "meaning": "rain",
      "tags": ["weather", "nature"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "あ"
      ]
    },
    "yuki": {
      "jp_character": "ゆき",
      "romanji": [
        "yuki"
      ],
      "sound": "ゆき",
      "meaning": "snow",
      "tags": ["weather", "nature"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "か"
      ]
    },
    "kaze": {
      "jp_character": "かぜ",
      "romanji": [
        "kaze"
      ],
      "sound": "かぜ",
      "meaning": "wind",
      "tags": ["weather", "nature"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か",
        "ざ"
      ]
    },
    "tenki": {
      "jp_character": "てんき",
      "romanji": [
        "tenki"
      ],
      "sound": "てんき",
      "meaning": "weather",
      "tags": ["weather"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "た",
        "か"
      ]
    },
    "atsui": {
      "jp_character": "あつい",
      "romanji": [
        "atsui"
      ],
      "sound": "あつい",
      "meaning": "hot",
      "tags": ["weather", "adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "た"
      ]
    },
    "suzushii": {
      "jp_character": "すずしい",
      "romanji": [
        "suzushii"
      ],
      "sound": "すずしい",
      "meaning": "cool",
      "tags": ["weather", "adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ざ",
        "あ",
        "さ"
      ]
    },
    "atarashii": {
      "jp_character": "あたらしい",
      "romanji": [
        "atarashii"
      ],
      "sound": "あたらしい",
      "meaning": "new",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "さ",
        "た"
      ]
    },
    "furui": {
      "jp_character": "ふるい",
      "romanji": [
        "furui"
      ],
      "sound": "ふるい",
      "meaning": "old",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "は"
      ]
    },
    "hayai": {
      "jp_character": "はやい",
      "romanji": [
        "hayai"
      ],
      "sound": "はやい",
      "meaning": "fast/early",
      "tags": ["adjectives", "time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "は"
      ]
    },
    "osoi": {
      "jp_character": "おそい",
      "romanji": [
        "osoi"
      ],
      "sound": "おそい",
      "meaning": "slow/late",
      "tags": ["adjectives", "time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "さ"
      ]
    },
    "tooi": {
      "jp_character": "とおい",
      "romanji": [
        "tooi"
      ],
      "sound": "とおい",
      "meaning": "far",
      "tags": ["adjectives", "distance"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "た"
      ]
    },
    "chikai": {
      "jp_character": "ちかい",
      "romanji": [
        "chikai"
      ],
      "sound": "ちかい",
      "meaning": "near",
      "tags": ["adjectives", "distance"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "た"
      ]
    },
    "nagai": {
      "jp_character": "ながい",
      "romanji": [
        "nagai"
      ],
      "sound": "ながい",
      "meaning": "long",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "な",
        "が",
        "あ"
      ]
    },
    "mijikai": {
      "jp_character": "みじかい",
      "romanji": [
        "mijikai"
      ],
      "sound": "みじかい",
      "meaning": "short",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "ざ",
        "あ",
        "か"
      ]
    },
    "hiroi": {
      "jp_character": "ひろい",
      "romanji": [
        "hiroi"
      ],
      "sound": "ひろい",
      "meaning": "wide/spacious",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "は"
      ]
    },
    "semai": {
      "jp_character": "せまい",
      "romanji": [
        "semai"
      ],
      "sound": "せまい",
      "meaning": "narrow",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "あ",
        "さ"
      ]
    },
    "oishii": {
      "jp_character": "おいしい",
      "romanji": [
        "oishii"
      ],
      "sound": "おいしい",
      "meaning": "delicious",
      "tags": ["adjectives", "food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "さ"
      ]
    },
    "mazui": {
      "jp_character": "まずい",
      "romanji": [
        "mazui"
      ],
      "sound": "まずい",
      "meaning": "bad tasting",
      "tags": ["adjectives", "food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "ざ",
        "あ"
      ]
    },
    "umai": {
      "jp_character": "うまい",
      "romanji": [
        "umai"
      ],
      "sound": "うまい",
      "meaning": "delicious/skillful",
      "tags": ["adjectives", "food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "あ"
      ]
    },
    "genki": {
      "jp_character": "げんき",
      "romanji": [
        "genki"
      ],
      "sound": "げんき",
      "meaning": "energetic/healthy",
      "tags": ["adjectives", "feelings"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "か",
        "が"
      ]
    },
    "kirei": {
      "jp_character": "きれい",
      "romanji": [
        "kirei"
      ],
      "sound": "きれい",
      "meaning": "pretty/clean",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "か"
      ]
    },
    "kitanai": {
      "jp_character": "きたない",
      "romanji": [
        "kitanai"
      ],
      "sound": "きたない",
      "meaning": "dirty",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "な",
        "あ",
        "か",
        "た"
      ]
    },
    "shizuka": {
      "jp_character": "しずか",
      "romanji": [
        "shizuka"
      ],
      "sound": "しずか",
      "meaning": "quiet",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ざ",
        "か",
        "さ"
      ]
    },
    "urusai": {
      "jp_character": "うるさい",
      "romanji": [
        "urusai"
      ],
      "sound": "うるさい",
      "meaning": "noisy",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "さ"
      ]
    },
    "benri": {
      "jp_character": "べんり",
      "romanji": [
        "benri"
      ],
      "sound": "べんり",
      "meaning": "convenient",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ば",
        "ら",
        "わ"
      ]
    },
    "michi": {
      "jp_character": "みち",
      "romanji": [
        "michi"
      ],
      "sound": "みち",
      "meaning": "road/path",
      "tags": ["places", "directions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "た"
      ]
    },
    "eki": {
      "jp_character": "えき",
      "romanji": [
        "eki"
      ],
      "sound": "えき",
      "meaning": "station",
      "tags": ["places", "transportation"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か"
      ]
    },
    "machi": {
      "jp_character": "まち",
      "romanji": [
        "machi"
      ],
      "sound": "まち",
      "meaning": "town/city",
      "tags": ["places"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "た"
      ]
    },
    "yama": {
      "jp_character": "やま",
      "romanji": [
        "yama"
      ],
      "sound": "やま",
      "meaning": "mountain",
      "tags": ["nature", "places"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ま"
      ]
    },
    "umi": {
      "jp_character": "うみ",
      "romanji": [
        "umi"
      ],
      "sound": "うみ",
      "meaning": "sea/ocean",
      "tags": ["nature", "places"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "あ"
      ]
    },
    "kawa": {
      "jp_character": "かわ",
      "romanji": [
        "kawa"
      ],
      "sound": "かわ",
      "meaning": "river",
      "tags": ["nature", "places"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "か"
      ]
    },
    "sora": {
      "jp_character": "そら",
      "romanji": [
        "sora"
      ],
      "sound": "そら",
      "meaning": "sky",
      "tags": ["nature"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "さ"
      ]
    },
    "tsuki": {
      "jp_character": "つき",
      "romanji": [
        "tsuki"
      ],
      "sound": "つき",
      "meaning": "moon",
      "tags": ["nature"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か",
        "た"
      ]
    },
    "hoshi": {
      "jp_character": "ほし",
      "romanji": [
        "hoshi"
      ],
      "sound": "ほし",
      "meaning": "star",
      "tags": ["nature"],
      "katakana_groups": [],
      "hiragana_groups": [
        "は",
        "さ"
      ]
    },
    "taiyou": {
      "jp_character": "たいよう",
      "romanji": [
        "taiyou"
      ],
      "sound": "たいよう",
      "meaning": "sun",
      "tags": ["nature"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "た"
      ]
    },
    "inu": {
      "jp_character": "いぬ",
      "romanji": [
        "inu"
      ],
      "sound": "いぬ",
      "meaning": "dog",
      "tags": ["animals", "pets"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "な"
      ]
    },
    "sakana": {
      "jp_character": "さかな",
      "romanji": [
        "sakana"
      ],
      "sound": "さかな",
      "meaning": "fish",
      "tags": ["animals", "food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "さ",
        "か",
        "な"
      ]
    },
    "sensei": {
      "jp_character": "せんせい",
      "romanji": [
        "sensei"
      ],
      "sound": "せんせい",
      "meaning": "teacher",
      "tags": ["people", "education"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "あ",
        "さ"
      ]
    },
    "gakusei": {
      "jp_character": "がくせい",
      "romanji": [
        "gakusei"
      ],
      "sound": "がくせい",
      "meaning": "student",
      "tags": ["people", "education"],
      "katakana_groups": [],
      "hiragana_groups": [
        "が",
        "あ",
        "か",
        "さ"
      ]
    },
    "tomodachi": {
      "jp_character": "ともだち",
      "romanji": [
        "tomodachi"
      ],
      "sound": "ともだち",
      "meaning": "friend",
      "tags": ["people", "social"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "だ",
        "た"
      ]
    },
    "hito": {
      "jp_character": "ひと",
      "romanji": [
        "hito"
      ],
      "sound": "ひと",
      "meaning": "person",
      "tags": ["people"],
      "katakana_groups": [],
      "hiragana_groups": [
        "は",
        "た"
      ]
    },
    "otoko": {
      "jp_character": "おとこ",
      "romanji": [
        "otoko"
      ],
      "sound": "おとこ",
      "meaning": "man",
      "tags": ["people"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "た"
      ]
    },
    "onna": {
      "jp_character": "おんな",
      "romanji": [
        "onna"
      ],
      "sound": "おんな",
      "meaning": "woman",
      "tags": ["people"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "あ",
        "な"
      ]
    },
    "asa": {
      "jp_character": "あさ",
      "romanji": [
        "asa"
      ],
      "sound": "あさ",
      "meaning": "morning",
      "tags": ["time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "さ"
      ]
    },
    "hiru": {
      "jp_character": "ひる",
      "romanji": [
        "hiru"
      ],
      "sound": "ひる",
      "meaning": "afternoon/noon",
      "tags": ["time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "は"
      ]
    },
    "ban": {
      "jp_character": "ばん",
      "romanji": [
        "ban"
      ],
      "sound": "ばん",
      "meaning": "evening",
      "tags": ["time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ば"
      ]
    },
    "yoru": {
      "jp_character": "よる",
      "romanji": [
        "yoru"
      ],
      "sound": "よる",
      "meaning": "night",
      "tags": ["time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ら"
      ]
    },
    "ima": {
      "jp_character": "いま",
      "romanji": [
        "ima"
      ],
      "sound": "いま",
      "meaning": "now",
      "tags": ["time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "あ"
      ]
    },
    "mainichi": {
      "jp_character": "まいにち",
      "romanji": [
        "mainichi"
      ],
      "sound": "まいにち",
      "meaning": "every day",
      "tags": ["time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "あ",
        "な",
        "た"
      ]
    },
    "totemo": {
      "jp_character": "とても",
      "romanji": [
        "totemo"
      ],
      "sound": "とても",
      "meaning": "very",
      "tags": ["adverbs"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "た"
      ]
    },
    "sukoshi": {
      "jp_character": "すこし",
      "romanji": [
        "sukoshi"
      ],
      "sound": "すこし",
      "meaning": "a little",
      "tags": ["adverbs"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か",
        "さ"
      ]
    },
    "takusan": {
      "jp_character": "たくさん",
      "romanji": [
        "takusan"
      ],
      "sound": "たくさん",
      "meaning": "many/a lot",
      "tags": ["adverbs"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "か",
        "さ",
        "た"
      ]
    },
    "amari": {
      "jp_character": "あまり",
      "romanji": [
        "amari"
      ],
      "sound": "あまり",
      "meaning": "not very",
      "tags": ["adverbs"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "ら",
        "あ"
      ]
    },
    "migi": {
      "jp_character": "みぎ",
      "romanji": [
        "migi"
      ],
      "sound": "みぎ",
      "meaning": "right",
      "tags": ["directions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "が"
      ]
    },
    "hidari": {
      "jp_character": "ひだり",
      "romanji": [
        "hidari"
      ],
      "sound": "ひだり",
      "meaning": "left",
      "tags": ["directions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "だ",
        "は"
      ]
    },
    "ue": {
      "jp_character": "うえ",
      "romanji": [
        "ue"
      ],
      "sound": "うえ",
      "meaning": "above/up",
      "tags": ["directions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ"
      ]
    },
    "shita": {
      "jp_character": "した",
      "romanji": [
        "shita"
      ],
      "sound": "した",
      "meaning": "below/down",
      "tags": ["directions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "さ",
        "た"
      ]
    },
    "naka": {
      "jp_character": "なか",
      "romanji": [
        "naka"
      ],
      "sound": "なか",
      "meaning": "inside",
      "tags": ["directions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "な",
        "か"
      ]
    },
    "soto": {
      "jp_character": "そと",
      "romanji": [
        "soto"
      ],
      "sound": "そと",
      "meaning": "outside",
      "tags": ["directions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "さ",
        "た"
      ]
    },
    "mae": {
      "jp_character": "まえ",
      "romanji": [
        "mae"
      ],
      "sound": "まえ",
      "meaning": "front/before",
      "tags": ["directions", "time"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "あ"
      ]
    },
    "ushiro": {
      "jp_character": "うしろ",
      "romanji": [
        "ushiro"
      ],
      "sound": "うしろ",
      "meaning": "back/behind",
      "tags": ["directions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "さ",
        "あ"
      ]
    },
    "となri": {
      "jp_character": "となり",
      "romanji": [
        "tonari"
      ],
      "sound": "となり",
      "meaning": "next to",
      "tags": ["directions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "な",
        "た"
      ]
    },
    "aida": {
      "jp_character": "あいだ",
      "romanji": [
        "aida"
      ],
      "sound": "あいだ",
      "meaning": "between",
      "tags": ["directions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "だ"
      ]
    },
    "gohan": {
      "jp_character": "ごはん",
      "romanji": [
        "gohan"
      ],
      "sound": "ごはん",
      "meaning": "rice/meal",
      "tags": ["food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "は",
        "が"
      ]
    },
    "niku": {
      "jp_character": "にく",
      "romanji": [
        "niku"
      ],
      "sound": "にく",
      "meaning": "meat",
      "tags": ["food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "な",
        "か"
      ]
    },
    "ocha": {
      "jp_character": "おちゃ",
      "romanji": [
        "ocha"
      ],
      "sound": "おちゃ",
      "meaning": "tea",
      "tags": ["food", "drinks"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "た"
      ]
    },
    "kissaten": {
      "jp_character": "きっさてん",
      "romanji": [
        "kissaten"
      ],
      "sound": "きっさてん",
      "meaning": "cafe",
      "tags": ["places", "food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "さ",
        "た",
        "か"
      ]
    },
    "resutoran": {
      "jp_character": "レストラン",
      "romanji": [
        "resutoran"
      ],
      "sound": "レストラン",
      "meaning": "restaurant",
      "tags": ["places", "food"],
      "katakana_groups": [
        "ラ",
        "サ",
        "タ",
        "ワ"
      ],
      "hiragana_groups": []
    },
    "depaato": {
      "jp_character": "デパート",
      "romanji": [
        "depaato"
      ],
      "sound": "デパート",
      "meaning": "department store",
      "tags": ["places", "shopping"],
      "katakana_groups": [
        "ダ",
        "パ",
        "タ",
        "ア"
      ],
      "hiragana_groups": []
    },
    "yuubinkyoku": {
      "jp_character": "ゆうびんきょく",
      "romanji": [
        "yuubinkyoku"
      ],
      "sound": "ゆうびんきょく",
      "meaning": "post office",
      "tags": ["places"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "か",
        "ば",
        "わ"
      ]
    },
    "toshokan": {
      "jp_character": "としょかん",
      "romanji": [
        "toshokan"
      ],
      "sound": "としょかん",
      "meaning": "library",
      "tags": ["places", "education"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "か",
        "や",
        "さ",
        "た"
      ]
    },
    "kuni": {
      "jp_character": "くに",
      "romanji": [
        "kuni"
      ],
      "sound": "くに",
      "meaning": "country",
      "tags": ["places"],
      "katakana_groups": [],
      "hiragana_groups": [
        "か",
        "な"
      ]
    },
    "eigo": {
      "jp_character": "えいご",
      "romanji": [
        "eigo"
      ],
      "sound": "えいご",
      "meaning": "English language",
      "tags": ["languages", "education"],
      "katakana_groups": [],
      "hiragana_groups": [
        "が",
        "あ"
      ]
    },
    "namae": {
      "jp_character": "なまえ",
      "romanji": [
        "namae"
      ],
      "sound": "なまえ",
      "meaning": "name",
      "tags": ["basic"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "な",
        "あ"
      ]
    },
    "shigoto": {
      "jp_character": "しごと",
      "romanji": [
        "shigoto"
      ],
      "sound": "しごと",
      "meaning": "work/job",
      "tags": ["work"],
      "katakana_groups": [],
      "hiragana_groups": [
        "が",
        "さ",
        "た"
      ]
    },
    "kaisha": {
      "jp_character": "かいしゃ",
      "romanji": [
        "kaisha"
      ],
      "sound": "かいしゃ",
      "meaning": "company",
      "tags": ["work"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "か",
        "さ"
      ]
    },
    "okane": {
      "jp_character": "おかね",
      "romanji": [
        "okane"
      ],
      "sound": "おかね",
      "meaning": "money",
      "tags": ["shopping", "money"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "か",
        "な"
      ]
    },
    "omoi": {
      "jp_character": "おもい",
      "romanji": [
        "omoi"
      ],
      "sound": "おもい",
      "meaning": "heavy",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "あ"
      ]
    },
    "karui": {
      "jp_character": "かるい",
      "romanji": [
        "karui"
      ],
      "sound": "かるい",
      "meaning": "light",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "あ",
        "か"
      ]
    },
    "tsuyoi": {
      "jp_character": "つよい",
      "romanji": [
        "tsuyoi"
      ],
      "sound": "つよい",
      "meaning": "strong",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "た"
      ]
    },
    "yowai": {
      "jp_character": "よわい",
      "romanji": [
        "yowai"
      ],
      "sound": "よわい",
      "meaning": "weak",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "わ",
        "あ"
      ]
    },
    "omoshiro": {
      "jp_character": "おもしろ",
      "romanji": [
        "omoshiro"
      ],
      "sound": "おもしろ",
      "meaning": "interesting",
      "tags": ["adjectives"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ら",
        "ま",
        "さ",
        "あ"
      ]
    },
    "wakarimasu": {
      "jp_character": "わかります",
      "romanji": [
        "wakarimasu"
      ],
      "sound": "わかります",
      "meaning": "to understand",
      "tags": ["verbs", "understanding"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "ら",
        "わ",
        "か",
        "さ"
      ]
    },
    "dekimasu": {
      "jp_character": "できます",
      "romanji": [
        "dekimasu"
      ],
      "sound": "できます",
      "meaning": "can do/be able to",
      "tags": ["verbs", "ability"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "か",
        "さ",
        "だ"
      ]
    },
    "shousetsu": {
      "jp_character": "しょうせつ",
      "romanji": [
        "shousetsu"
      ],
      "sound": "しょうせつ",
      "meaning": "novel",
      "tags": ["items", "entertainment"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "さ",
        "た"
      ]
    },
    "eiga": {
      "jp_character": "えいが",
      "romanji": [
        "eiga"
      ],
      "sound": "えいが",
      "meaning": "movie",
      "tags": ["entertainment"],
      "katakana_groups": [],
      "hiragana_groups": [
        "が",
        "あ"
      ]
    },
    "ongaku": {
      "jp_character": "おんがく",
      "romanji": [
        "ongaku"
      ],
      "sound": "おんがく",
      "meaning": "music",
      "tags": ["entertainment"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "が",
        "あ",
        "か"
      ]
    },
    "geemu": {
      "jp_character": "ゲーム",
      "romanji": [
        "geemu"
      ],
      "sound": "ゲーム",
      "meaning": "game",
      "tags": ["entertainment", "otaku"],
      "katakana_groups": [
        "ガ",
        "マ"
      ],
      "hiragana_groups": []
    },
    "cosplay": {
      "jp_character": "コスプレ",
      "romanji": [
        "cosplay",
        "kosupure"
      ],
      "sound": "コスプレ",
      "meaning": "cosplay",
      "tags": ["otaku", "anime"],
      "katakana_groups": [
        "カ",
        "サ",
        "パ",
        "ラ"
      ],
      "hiragana_groups": []
    },
    "waifu": {
      "jp_character": "ワイフ",
      "romanji": [
        "waifu"
      ],
      "sound": "ワイフ",
      "meaning": "waifu",
      "tags": ["otaku", "anime"],
      "katakana_groups": [
        "ワ",
        "ア",
        "ハ"
      ],
      "hiragana_groups": []
    },
    "senpai": {
      "jp_character": "せんぱい",
      "romanji": [
        "senpai"
      ],
      "sound": "せんぱい",
      "meaning": "senior/upperclassman",
      "tags": ["school", "social"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ぱ",
        "あ",
        "さ"
      ]
    },
    "kouhai": {
      "jp_character": "こうはい",
      "romanji": [
        "kouhai"
      ],
      "sound": "こうはい",
      "meaning": "junior/underclassman",
      "tags": ["school", "social"],
      "katakana_groups": [],
      "hiragana_groups": [
        "は",
        "あ",
        "か"
      ]
    },
    "yandere": {
      "jp_character": "ヤンデレ",
      "romanji": [
        "yandere"
      ],
      "sound": "ヤンデレ",
      "meaning": "yandere character type",
      "tags": ["otaku", "anime"],
      "katakana_groups": [
        "ヤ",
        "ワ",
        "ダ",
        "ラ"
      ],
      "hiragana_groups": []
    },
    "tsundere": {
      "jp_character": "ツンデレ",
      "romanji": [
        "tsundere"
      ],
      "sound": "ツンデレ",
      "meaning": "tsundere character type",
      "tags": ["otaku", "anime"],
      "katakana_groups": [
        "タ",
        "ワ",
        "ダ",
        "ラ"
      ],
      "hiragana_groups": []
    },
    "mecha": {
      "jp_character": "メカ",
      "romanji": [
        "mecha"
      ],
      "sound": "メカ",
      "meaning": "mecha/robot",
      "tags": ["otaku", "anime"],
      "katakana_groups": [
        "マ",
        "カ"
      ],
      "hiragana_groups": []
    },
    "shounen": {
      "jp_character": "しょうねん",
      "romanji": [
        "shounen"
      ],
      "sound": "しょうねん",
      "meaning": "boy/shounen genre",
      "tags": ["otaku", "anime", "manga"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "わ",
        "さ"
      ]
    },
    "shoujo": {
      "jp_character": "しょうじょ",
      "romanji": [
        "shoujo"
      ],
      "sound": "しょうじょ",
      "meaning": "girl/shoujo genre",
      "tags": ["otaku", "anime", "manga"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "あ",
        "ざ",
        "さ"
      ]
    },
    "kawaisou": {
      "jp_character": "かわいそう",
      "romanji": [
        "kawaisou"
      ],
      "sound": "かわいそう",
      "meaning": "pitiful/poor thing",
      "tags": ["feelings", "expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "あ",
        "か",
        "さ"
      ]
    },
    "sugoi": {
      "jp_character": "すごい",
      "romanji": [
        "sugoi"
      ],
      "sound": "すごい",
      "meaning": "amazing/awesome",
      "tags": ["adjectives", "expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "が",
        "あ",
        "さ"
      ]
    },
    "yabai": {
      "jp_character": "やばい",
      "romanji": [
        "yabai"
      ],
      "sound": "やばい",
      "meaning": "dangerous/crazy/awesome",
      "tags": ["slang", "expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ば",
        "あ"
      ]
    },
    "kimochi": {
      "jp_character": "きもち",
      "romanji": [
        "kimochi"
      ],
      "sound": "きもち",
      "meaning": "feeling",
      "tags": ["feelings"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "か",
        "た"
      ]
    },
    "itai": {
      "jp_character": "いたい",
      "romanji": [
        "itai"
      ],
      "sound": "いたい",
      "meaning": "painful/ouch",
      "tags": ["feelings", "expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "あ",
        "た"
      ]
    },
    "daijoubu": {
      "jp_character": "だいじょうぶ",
      "romanji": [
        "daijoubu"
      ],
      "sound": "だいじょうぶ",
      "meaning": "okay/alright",
      "tags": ["expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "だ",
        "や",
        "あ",
        "ば"
      ]
    },
    "yokatta": {
      "jp_character": "よかった",
      "romanji": [
        "yokatta"
      ],
      "sound": "よかった",
      "meaning": "I'm glad/that's good",
      "tags": ["expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "か",
        "た"
      ]
    },
    "ganbatte": {
      "jp_character": "がんばって",
      "romanji": [
        "ganbatte"
      ],
      "sound": "がんばって",
      "meaning": "do your best/good luck",
      "tags": ["expressions", "encouragement"],
      "katakana_groups": [],
      "hiragana_groups": [
        "が",
        "わ",
        "ば",
        "た"
      ]
    },
    "omedetou": {
      "jp_character": "おめでとう",
      "romanji": [
        "omedetou"
      ],
      "sound": "おめでとう",
      "meaning": "congratulations",
      "tags": ["expressions"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "だ",
        "あ",
        "た"
      ]
    },
    "sumimasen": {
      "jp_character": "すみません",
      "romanji": [
        "sumimasen"
      ],
      "sound": "すみません",
      "meaning": "excuse me/sorry",
      "tags": ["expressions", "politeness"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "わ",
        "さ"
      ]
    },
    "itadakimasu": {
      "jp_character": "いただきます",
      "romanji": [
        "itadakimasu"
      ],
      "sound": "いただきます",
      "meaning": "let's eat (before meal)",
      "tags": ["expressions", "food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "ま",
        "だ",
        "あ",
        "か",
        "た",
        "さ"
      ]
    },
    "gochisousama": {
      "jp_character": "ごちそうさま",
      "romanji": [
        "gochisousama"
      ],
      "sound": "ごちそうさま",
      "meaning": "thank you for the meal (after eating)",
      "tags": ["expressions", "food"],
      "katakana_groups": [],
      "hiragana_groups": [
        "が",
        "ま",
        "さ",
        "た"
      ]
    },
    "ohayou": {
      "jp_character": "おはよう",
      "romanji": [
        "ohayou"
      ],
      "sound": "おはよう",
      "meaning": "good morning",
      "tags": ["expressions", "greetings"],
      "katakana_groups": [],
      "hiragana_groups": [
        "は",
        "や",
        "あ"
      ]
    },
    "konnichiwa": {
      "jp_character": "こんにちは",
      "romanji": [
        "konnichiwa"
      ],
      "sound": "こんにちは",
      "meaning": "hello/good afternoon",
      "tags": ["expressions", "greetings"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "は",
        "か",
        "た"
      ]
    },
    "konbanwa": {
      "jp_character": "こんばんは",
      "romanji": [
        "konbanwa"
      ],
      "sound": "こんばんは",
      "meaning": "good evening",
      "tags": ["expressions", "greetings"],
      "katakana_groups": [],
      "hiragana_groups": [
        "わ",
        "ば",
        "は",
        "か"
      ]
    },
    "oyasumi": {
      "jp_character": "おやすみ",
      "romanji": [
        "oyasumi"
      ],
      "sound": "おやすみ",
      "meaning": "good night",
      "tags": ["expressions", "greetings"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ま",
        "さ",
        "あ"
      ]
    },
    "sayounara": {
      "jp_character": "さようなら",
      "romanji": [
        "sayounara"
      ],
      "sound": "さようなら",
      "meaning": "goodbye",
      "tags": ["expressions", "greetings"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ら",
        "な",
        "さ",
        "あ"
      ]
    },
    "ja_mata": {
      "jp_character": "じゃまた",
      "romanji": [
        "ja mata",
        "jamata"
      ],
      "sound": "じゃまた",
      "meaning": "see you later",
      "tags": ["expressions", "greetings"],
      "katakana_groups": [],
      "hiragana_groups": [
        "や",
        "ま",
        "た",
        "ざ"
      ]
    }
  }
};